import {Component, OnInit, ViewChild} from "@angular/core";
import {Customer} from "../../../dto/customer";
import {
  calculateAge,
  DateFormats,
  formatPhone,
  formatPhoneNumeric, nationalityToCountry,
  phoneToCountry,
  toDateString,
  toDateTimeString
} from "../../../providers/app-date-adapter";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {CustomersService} from "../../services/customers.service";
import {DatePipe, Location} from "@angular/common";
import {Card, CustomerOverviewCardContainer} from "../../../dto/card";
import {CardsService} from "../../services/cards.service";

import {EventLog} from "../../../dto/event-log";
import {EventLogService} from "../../../services/crud/event-log.service";
import {ObjectComment} from "../../../dto/object-comment";
import {ObjectCommentsService} from "../../services/object-comment.service";
import {RoleService} from "../../../services/role.service";
import {OrdersService} from "../../services/orders.service";
import {
  AddressChangeStatus,
  AddressStatus,
  CardUsageStatus,
  IdentLevel,
  IdentStatus,
  WebIdTransactionProvider
} from "../../../dto/ident-status";
import {IdentContainer, WebIdTransaction} from "../../../dto/web-id-transaction";
import {WebIdTransactionService} from "../../services/webid-transaction.service";
import {FileHelper} from "../../../helpers/file-helper";
import {CardReorderDialogComponent} from "../../../shared/card-reorder-dialog/card-reorder-dialog.component";
import {CardExtensionModel, CardReorderModel} from "../../../models/card-reorder-model";
import {AnnualFeeDeduction, Invoice, MicroPaymentSession} from "../../../dto/invoice";
import {Order} from "../../../dto/order";
import {EmailSendStatus, OrderStatus} from "../../../dto/order-status";
import {OrderCancelDialogComponent} from "../../../shared/order-cancel-dialog/order-cancel-dialog.component";
import {OrderCancellationModel} from "../../../models/order-cancellation-model";
import {Country} from "../../../dto/country";
import {CountryService} from "../../../services";
import {PHONE_MASK} from "../../../helpers/format-helpers";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomerIban, Product} from "../../../dto/product";
import {ProductService} from "../../services/product.service";
import {InvoicesService} from "../../services/invoices.service";
import {ResendWebidDialogComponent} from "../../../shared/resend-webid/resend-webid-dialog.component";
import {ResendWebidModel} from "../../../models/resend-webid-model";
import {getTableFilters} from "../../../helpers/storage-helper";

import {SendUploadLinkDialogComponent} from "../../../shared/send-upload-link/send-upload-link-dialog.component";
import {SendUploadLinkModel} from "../../../models/send-upload-link-model";
import {DeviceLoggedIn, IdvUploadDto} from "../../../dto/idv-upload";
import {ConfirmDialogComponent} from "../../../shared/confirm-dialog/confirm-dialog.component";
import {CardbroGatewayService} from "../../services/cardbro-gateway.service";
import {Transaction, TransactionEx} from "../../../dto/CardbroGateway/transaction";
import {MatPaginator} from "@angular/material/paginator";
import {CardHolderDetails} from "../../../dto/CardbroGateway/cardholder-details";
import {CardInfo} from "../../../dto/CardbroGateway/card-info";
import {ChangeEmailDialogComponent} from "../../../shared/change-email-dialog/change-email-dialog.component";
import {ChangeEmailModel} from "../../../models/change-email-model";
import {
  ChangeCustomerPhoneDialogComponent
} from "../../../shared/change-customer-phone-dialog/change-customer-phone-dialog.component";
import {ChangePhoneModel} from "../../../models/change-phone-model";
import {AddressUploadDto} from "../../../dto/address-upload";
import {CompanyService} from "../../services/company.service";
import {
  CardCancellationDialogComponent
} from "../../../shared/card-cancellation-dialog/card-cancellation-dialog.component";
import {CardCancellationModel} from "../../../models/card-cancellation-model";
import {CustomerEmailLogDto} from "../../../dto/customer-email-log-dto";
import {RiskAssementInquiry} from "../../../dto/risk-assement-inquiry";
import {RiskService} from "../../services/risk.service";
import {BankTransferLoadService} from "../../../bank-transfer-load.service";
import {AmountAndCurrencyContainer, BankTransferLoad} from "../../../dto/bankTransferLoad";
import {ShowDialogWithLinkComponent} from "../../../shared/show-dialog-with-link/show-dialog-with-link.component";
import {IdvCustomersService} from "../../services/idv-customers.service";
import {ToastService} from "angular-toastify";
import {byNumeric} from "iso-country-codes";
import {MatTableDataSource} from "@angular/material/table";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {PepStatus} from "../../../dto/pep-status";
import {CashbackGroup, CashbackGroupMembership} from "../../../dto/cashbackGroup";
import {
  AddCardToCashbackGroupDialogComponent
} from "../../administration/cashback-groups/add-card-to-cashback-group-dialog/add-card-to-cashback-group-dialog.component";
import {CashbackGroupsService} from "../../../cashback-groups.service";
import {RiskOverviewService} from "../../services/risk-overview.service";
import {CustomerRisk} from "../../../dto/customer-risk";
import {CardToCardTransfer, WhiteListedBankAccount} from "../../../dto/trustPayTransaction";
import {
  CustomerIdentEditDialogComponent
} from "../../customers/customer-ident-edit-dialog/customer-ident-edit-dialog.component";
import {CustomerIdentDocumentModel} from "../../../models/customer-ident-document-model";
import {GeoIpService} from "../../../services/geo-ip.service";
import {CityInfo} from "../../../dto/GeoIp/city-info";
import {CardReorderReason} from "../../../dto/card-reorder-reason";
import {CustomersOverviewService} from "../../../services/customers-overview.service";
import {PrevNextIdModel} from "../../../models/prev-next-id-model";
import {GpsCardStatusHelper} from "../../../dto/gps-card-status";
import {Company} from "../../../dto/company";
import {DateTableFilter} from "../../../table-datasouces/date-table-filter";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {CardExtensionDialogComponent} from "../../../shared/card-extension-dialog/card-extension-dialog.component";
import {
  StatusChangeReasonDialogComponent
} from "../../../shared/status-change-reason-dialog/status-change-reason-dialog.component";
import {ReorderDelayReason} from "../../../dto/reorder-delay-reason";
import {AddCardOrderDialogComponent} from "../../../shared/add-card-order-dialog/add-card-order-dialog.component";
import {CreateCardOrderModel} from "../../../models/create-card-order-model";
import {SmsDeliveryLog} from "../../../dto/smsDeliveryLog";
import {CustomerCashback} from "../../../models/customer-cashback";
import {
  getIdentStatusColor,
  getIdentStatusIcon,
  getIdentStatusText,
  getPepStatusColor,
  getPepStatusText
} from "../../../helpers/pep-status-helper";
import {
  RestoreAnonymizedDialogComponent
} from "../../customers/restore-anonymized-dialog/restore-anonymized-dialog.component";
import {FcmSent} from "../../../dto/fcm-sent";
import {
  AuthenticationMethod,
  CardDataInputMethod,
  CardholderPresent,
  CardPresent,
  GPSPosData, parseGPSPosData,
  SCATestResult,
  ThreeDSecureAuthMethod
} from "../../../helpers/gps-pos-data-helper";
import {AnnualFeeDeductionService} from "../../services/annual-fee-deduction.service";
import {MicroPaymentService} from "../../services/micro-payment.service";
import {environment} from "../../../../environments/environment";
import {AnnualFeeService} from "../../../services/annual-fee.service";
import {AnnualFee} from "../../../dto/annualFee";
import {MarkVulnerableDialogComponent} from "../../customers/mark-vulnerable-dialog/mark-vulnerable-dialog.component";
import {MarkCustomerAsVulnerableModel} from "../../../models/mark-customer-as-vulnerable-model";
import {ETransactionStatus, StatementLineDto} from "../../../dto/CardbroGateway/statement";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {CardType} from "../../../dto/cardInfoModelBase";


@Component({
  selector: 'app-customer-overview-detail',
  templateUrl: './customer-overview-detail.component.html',
  styleUrls: ['./customer-overview-detail.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class CustomerOverviewDetailComponent implements OnInit {
  previewUrl: string|null;
  displayImagePreview = false;
  displayVideoPreview = false;
  previewFileOpen = false;
  previewType = 0;
  previewUrlSafe: SafeResourceUrl;
  previewFilename: string|null;
  previewErrorMsg: string|null;
  isLoadingCards= false;
  isLoadingIdentFiles= false;
  isOrderingNewCard = false;
  cashbacks: CustomerCashback[];
  smsDeliveries: SmsDeliveryLog[];

  isReorderingCard = false;
  isLoadingDevicesLoggedIn = false
  devicesLoggedIn: DeviceLoggedIn[] = [];
  isLoadingBankTransferLoads = false;
  isAnonymizing = false;
  isUpdatingCustomer = false;
  annualFeeDeductions: AnnualFeeDeduction[] = [];
  microPaymentSessions: MicroPaymentSession[] = [];
  whiteListedBankAccounts: WhiteListedBankAccount[] = [];
  productLogoUrl: { [key: number]: string } = {};
  annualFees: AnnualFee[] = [];


  yearsSinceAccountCreation: number;
  isLoadingIbans = false
  ibans: CustomerIban[] = [];

  getIbanStatusString1(statusId: number): string {
    return statusId.toString();
  }
  prettyPrintIban(iban: string): string {
    if ( iban == null )
      return null;
    // Remove any existing spaces or non-alphanumeric characters
    const cleanIban = iban.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    // Insert a space every 4 characters
    return cleanIban.replace(/(.{4})(?=.)/g, '$1 ');
  }

  constructor(
    private _toastService: ToastService,
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private customersService: CustomersService,
    private customersOverviewService: CustomersOverviewService,
    private cardsService: CardsService,
    private cardbroGatewayService: CardbroGatewayService,
    private roleService: RoleService,
    private snackBar: MatSnackBar,
    private logService: EventLogService,
    private objectCommentsService: ObjectCommentsService,
    private ordersService: OrdersService,
    private transactionService: WebIdTransactionService,
    private dialog: MatDialog,
    private countryService: CountryService,
    private productService: ProductService,
    private invoicesService: InvoicesService,
    private annualFeeDeductionService: AnnualFeeDeductionService,
    private annualFeeService: AnnualFeeService,
    private microPaymentService: MicroPaymentService,

    private companyService: CompanyService,
    private riskService: RiskService,
    private bankTransferLoadService: BankTransferLoadService,
    private idvCustomersService: IdvCustomersService,
    private cashbackGroupsService: CashbackGroupsService,
    private riskOverviewService: RiskOverviewService,
    private geoIpService: GeoIpService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
  ) {
  }


  public customerOverviewFilters: DateTableFilter|null = null; // this is for the persistent sort field


  // search fields
  public webIdStatusSelect = new FormControl();
  public companySelect = new FormControl();
  public countriesSelect = new FormControl();
  public companies: Company[];
  public countries: Country[];
  public webIdStatus = IdentStatus;

  onWebStatusChange() {
    this.triggerSearch();
  }

  onCompanyChange() {
    this.customerOverviewFilters.someAdditionalData = 'companyid_' + this.companySelect.value; // TODO heavy abuse
    this.triggerSearch();
  }

  onCountryChange() {
    this.customerOverviewFilters.countriesFilter = this.countriesSelect.value as string[];
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch();
  }


  previewIdentFile(uploadId: number) {
    this.isLoadingCustomer = true;
    this.previewFileOpen = true;
    this.customersService.getIdentFileInline( uploadId ).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        if ( contentType == 'application/pdf' || contentType == 'application/zip') {
          this.previewErrorMsg = null;
          this.previewFilename = filename;
          this.isLoadingCustomer = false;

          FileHelper.saveFile( result );
          return;
        }


        const blob = new Blob([result.body], { type: contentType });
        // FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.previewUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if ( contentType.indexOf('image') >= 0) {
          this.previewType = 2;
        } else {
          this.previewType = 1;
        }
        this.previewErrorMsg = null;
        this.previewFilename = filename;
        this.isLoadingCustomer = false;

        // FileHelper.saveFile( result );
      },
      err => {
        this.previewFilename = null;
        this.previewType = 0;
        this.previewErrorMsg = 'Error occured during downloading the file.';
        this.isLoadingCustomer = false;
        this._toastService.error( err.error.message || err.message || err.error || err);
      }

    );
  }

  onSearch(isInvalid = false) {

    if (!isInvalid) {


      // {"str":null,"dateFilterCols":null,"startFilterDate":null,"endFilterDate":null,"companiesFilter":null,"identStatusFilter":null,"sortField":"id","sortDirection":"desc","someAdditionalData":null,"additionalFilterData":null,"enumFilter":null,"additionalField1":null,"additionalField2":null,"additionalValue1":null,"additionalValue2":null,"page":0,"pageSize":20}
      // save filter
      sessionStorage.setItem('customerOverviewTable', JSON.stringify(this.customerOverviewFilters));
      // go to customer overview
      this.router.navigate(['..'], {relativeTo: this.route});




    }
  }

  clearFilter() {
    this.webIdStatusSelect.patchValue(null);
    this.companySelect.patchValue(null);
    this.countriesSelect.patchValue(null);
    this.customerOverviewFilters.str = '';
    sessionStorage.setItem('customerOverviewTable', JSON.stringify(this.customerOverviewFilters));
    // go to customer overview
    this.router.navigate(['..'], {relativeTo: this.route});
  }



  ipCityInfo: CityInfo|null;
  loadingPrevNext = false;
  loadingPrev = false;
  loadingNext = false;
  isLoadingRisk = false;
  isLoadingCustomer = false;
  isExtendingCard = false;
  isQueueingCardForConversion = false;
  isIssuingPseudoCard = false;
  isLoadingComments = false;
  isLoadingInvoices = false;
  isLoadingAnnualFees = false;
  isLoadingAnnualFeeDeductions = false;
  isLoadingMicroPaymentSessions = false;
  isLoadingWhiteListedBankAccounts = false;
  isLoadingSmsEmailLogs = false;
  isLoadingFcmSents = false;
  isLoadingIdentLog = false;
  isLoadingIdvSof = false;
  isLoadingAllDocuments = false;
  isLoadingLoads = false;

  isLoadingLogs = false;
  inboundCardToCardTransfers: CardToCardTransfer[]|null;


  identStatus = IdentStatus;
  pepStatus = PepStatus;
  cardReorderReason = CardReorderReason;

  types: { [key: string]: string } = {
    INVOICE: 'Invoice',
    VOUCHER: 'Voucher',
    SOFORT: 'Sofort',
    CASH: 'Cash on delivery',
    CREDIT_CARD: 'Credit Card',
    NO_PAYMENT: 'No payment'
  };

  customer: Customer;
  customerSolr: Customer;
  customerRisk: CustomerRisk;

  public newIdvLevelSelect: IdentLevel|null;
  public newPepStatusToSelect: PepStatus|null;
  public newAddressStatusSelect: AddressStatus|null;
  public identLevel = IdentLevel;
  public addressStatus = AddressStatus;

  idents: IdentContainer[] = [];
  idvUploadFiles: IdvUploadDto[];
  addressConfirmationFiles: IdvUploadDto[];
  allDocuments: IdvUploadDto[];
  addressUploadFiles: AddressUploadDto[];

  prevNextIds: PrevNextIdModel;

  logs: EventLog[];
  fcmSents: FcmSent[];
  customerId: number;
  isWebIdDownloadVisible = false;
  // customer
  comments: ObjectComment[];
  commentsTarget = 1;

  // invoice
  commentsInvoiceTarget = 3;

  docPaidText = '';

  number = Number;
  loadingOrder: boolean;

  // for customeredit
  showCustomerEdit: boolean;
  countiries: Country[];
  phoneMask = PHONE_MASK;
  customerForm: FormGroup;

  // for ordersedit
  orders = [] as
    {
      id: number;
      order: Order;
      editVisible: boolean;
      editForm: FormGroup;

      invoice: Invoice;
      invoiceEditVisible: boolean;
      invoiceEditForm: FormGroup;
      invoiceComments: ObjectComment[];
    }[];

  cardContainers: CustomerOverviewCardContainer[] = [];
  cardUsageStatus = CardUsageStatus;
  reorderDelayReason = ReorderDelayReason;

  cardType = CardType;

  // for addons


  products: Product[];

  fields = [
    {header: 'External ID', cell: (row: Customer) => row.extId},
    {header: 'Referral Code', cell: (row: Customer) => row.referralCode},
    {header: 'Mobile', cellFlag: (row: Customer) => phoneToCountry(''+row.phone), cell: (row: Customer) => `+${row.phone || ''}`},
    { header: 'Email',
      icon: (row: Customer) => this.getEmailIcon(row),
      cellColor: (row: Customer) => this.getEmailIconColor(row),
      iconColor: (row: Customer) => this.getEmailIconColor(row),
      cell: (row: Customer) => `${row.email || ''}`
    },
    {header: 'Date of birth', cell: (row: Customer) => {
        if ( !row.dob ) {
          return '-';
        }
        return toDateString(row.dob);
      }},
    {header: 'Nationality', cellFlag: (row: Customer) => nationalityToCountry(row.nationality), cell: (row: Customer) => {
        if ( !row.nationality ) {
          return '(Unknown)';
        }
        return row.nationality;
      }},
    {header: 'Age', cell: (row: Customer) => {
        if ( !row.dob ) {
          return '-';
        }
        return calculateAge(row.dob) + ' years';
      }},
    /*{header: 'Name', cell: (row: Customer) => `${row.title || ''} ${row.firstName} ${row.lastName}`} as ContentRowField<Customer>,*/
    /*{ header: "Title", cell: (row: Customer) => `${row.title}` },
    { header: "First name", cell: (row: Customer) => `${row.firstName || ""}` },
    { header: "Last name", cell: (row: Customer) => `${row.lastName || ""}` },*/
    {header: 'Address', cell: (row: Customer) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}`},
    {header: 'Country', cellFlag: (row: Customer) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row: Customer) => `${row.countryName || ''}`},
    /*{ header: "Address", cell: (row: Customer) => `${row.address || ""}` },
    { header: "City", cell: (row: Customer) => `${row.city || ""}` },
    { header: "Zip code", cell: (row: Customer) => `${row.zipCode || ""}` },*/





    /*{header: "Age", cell: (row: Customer) => {
        if ( !row.dob )
          return "-";
        return toAge(row.dob) + " years"
      }},*/
    {
      header: 'Order language'
      , cellFlag: (row: Customer) => {
        if (row.orderLanguage == 0) {
          return 'de';
        } else {
          return 'gb';
        }
      }

      , cell: (row: Customer) => {
        if (row.orderLanguage == 0) {
          return 'german';
        } else {
          return 'english';
        }
      }
    },
    {header: 'IP Address', cellFlag: (row: Customer) => this.ipCityInfo?.countryAlphaIsoCode || null
      , cell: (row: Customer) => {
        const ret = row.ipAddress || '';
        if ( ret && this.ipCityInfo ) {
          //ret += " (" + this.ipCityInfo.postCode + " " + this.ipCityInfo.city + " " + this.ipCityInfo.countryName + ")"
        }
        return ret;

      }},
    {header: 'Subscribed to news', cell: (row: Customer) => `${row.subscribeToNews ? 'Yes' : 'No' || ''}`},
    {
      header: 'Ident',
      iconColor: row => getIdentStatusColor(row.identStatus),
      icon: (row: Customer) => getIdentStatusIcon(row.identStatus),
      cell: row => getIdentStatusText(row.identStatus),
    } as ContentRowField<Customer>,
    {
      header: 'PEP Status',
      iconColor: (row: Customer) => getPepStatusColor(row.pepStatus), icon: (row: Customer) => 'perm_identity',
      cell: (row: Customer) => getPepStatusText(row.pepStatus),
    },
    {
      header: 'Address Status',
      iconColor: (row: Customer) => {

        if (row.addressStatus == AddressStatus.Confirmed) {
return '#8bc34a';
}
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
return '#4a82c3';
}
        if (row.addressStatus == AddressStatus.PendingCheck) {
return '#684ac3';
}

        return '#d04848';
      },
      icon: (row: Customer) => {
        if (row.addressStatus == AddressStatus.Confirmed) {
return 'place';
}
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
return 'not_listed_location';
}
        if (row.addressStatus == AddressStatus.PendingCheck) {
return 'not_listed_location';
}

        return 'not_listed_location';
      }, cell: (row: Customer) => {
        if (row.addressStatus == AddressStatus.Confirmed) {
return 'Confirmed';
}
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
return 'Waiting for documents';
}
        if (row.addressStatus == AddressStatus.PendingCheck) {
return 'Pending check';
}

        return 'Unconfirmed';
      }},



    {
      header: 'Address Change Status',
      iconColor: (row: Customer) => {

        if (row.addressChangeStatus == AddressChangeStatus.WaitingForDocuments) {
          return '#4a82c3';
        }
        if (row.addressChangeStatus == AddressChangeStatus.PendingCheck) {
          return '#684ac3';
        }

        return '#ffffff';
      },
      icon: (row: Customer) => {
        if (row.addressChangeStatus == AddressChangeStatus.WaitingForDocuments) {
          return 'not_listed_location';
        }
        if (row.addressChangeStatus == AddressChangeStatus.PendingCheck) {
          return 'not_listed_location';
        }

        return '';
      }, cell: (row: Customer) => {
        if (row.addressChangeStatus == AddressChangeStatus.WaitingForDocuments) {
          return 'Waiting for documents';
        }
        if (row.addressChangeStatus == AddressChangeStatus.PendingCheck) {
          return 'Pending check';
        }

        return '';
      }},




    /*{
      header: "IDV Link Status", cell: (row: Customer) => {
        if (row.idvSuccess == null) {
          return "-";
        }
        if (row.idvSuccess) {
          return "Success";
        } else {
          return "Failed";
        }
      }
    },
    {
      header: "Docs Link Status", cell: (row: Customer) => {
        if (row.docsSuccess == null) {
          return "-";
        }
        if (row.docsSuccess) {
          return "Success";
        } else {
          return "Failed";
        }
      }
    },*/

  ] as ContentRowField<Customer>[];

  ordersFields = [
    {header: 'Order ID', cell: (row: number) => `${this.orders[row].order.id || ''}`},
    {header: 'Order date', cell: (row: number) => `${toDateString(this.orders[row].order.orderDate) || ''}`},
    {header: 'Shipping date', cell: (row: number) => `${toDateString(this.orders[row].order.shippedDate) || ''}`},
    {header: 'Status', cell: (row: number) => `${this.orders[row].order.statusName || ''}`},
    {
      header: 'Cancellation Status', cell: (row: number) => {
        if (this.orders[row].order.cancellationStatus != null && this.orders[row].order.cancellationStatus == 1) {
          return 'Pending';
        }
        if (this.orders[row].order.cancellationStatus != null && this.orders[row].order.cancellationStatus == 2) {
          return 'Done';
        }
        return '-';

      }
    },
    {
      header: 'Ident',
      cell: (row: number) => `${IdentStatus[(this.orders[row].order.webIdTransaction || ({} as WebIdTransaction)).status] || 'not required'}`
    },
    // { header: "WebID status", cell: ( row: number ) => `${ WebIdTransactionStatus[(this.orders[row].order.webIdTransaction || ({} as WebIdTransaction)).status] || "WebID Was not required" }` },
    // { header: "Response File", cell: ( row: number ) => `${ (this.orders[row].order.webIdTransaction || ({} as WebIdTransaction)).responseFileId || "No File Yet" }`, type: "button" },
  ];


  ordersFields2 = [
    // { header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },
    // { header: "Card name", cell: (row: Order) => `${row.cardName}` },
    // { header: "Invoice number", link: (row: Order) => (row ? `/invoices/by-number/${row.invoiceNumber}` : null), cell: (row: Order) => `${row.invoiceNumber || "Voucher"}` },
    {header: 'Sex', cell: (row: Order) => `${row.sex}`},

    {header: 'Name', cell: (row: Order) => `${row.title} ${row.firstName} ${row.lastName}`},
    {header: 'Company', cell: (row: Order) => `${row.customerCompanyName != null ? row.customerCompanyName : '-'}`},
    /*{ header: "Title", cell: (row: Order) => `${row.title}` },
    { header: "First Name", cell: (row: Order) => `${row.firstName}` },
    { header: "Last Name", cell: (row: Order) => `${row.lastName}` },*/

    {header: 'Date of birth', cell: (row: Order) => `${toDateString(row.dob) || ''}`},
    {header: 'Email', cell: (row: Order) => `${row.email}`},
    {header: 'Mobile', cellFlag: (row: Order) => phoneToCountry(''+row.phone), cell: (row: Order) => `${formatPhoneNumeric(row.phone)}`},
    {header: 'Product', cell: (row: Order) => `${row.productName}`},
    {header: 'Company', cell: (row: Order) => `${row.companyName}`},

    {header: 'Address', cell: (row: Order) => `${row.address}, ${row.zipCode} ${row.city}`},
    /*
    { header: "Address", cell: (row: Order) => `${row.address}` },
    { header: "City", cell: (row: Order) => `${row.city}` },
    { header: "Zip Code", cell: (row: Order) => `${row.zipCode}` },
    */
    {header: 'Country', cell: (row: Order) => `${row.countryName}`},
    {header: 'Nationality', cell: (row: Order) => `${row.nationality}`},
    {
      header: 'Order language', cell: (row: Order) => {
        if (row.orderLanguage == 0) {
          return 'german';
        } else {
          return 'english';
        }
      }
    },

    { header: 'Load amount', icon: (row: Order) => {
        if ( row.loadAmount > 0 ) {
          return 'caret-right-circle';
        }
        return null;
      },
      iconColor: (row: Order) => {
        if ( row.loadAmount > 0 ) {
          return 'dodgerblue';
        }
        return null;
      }, cell: (row: Order) => `${row.loadAmount || ''}` } as ContentRowField<Order>,


    {header: 'Ip Address', cell: (row: Order) => `${row.ipAddress}`},
    {header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}`},
    {header: 'Shipping date', cell: (row: Order) => `${toDateString(row.shippedDate) || ''}`},
    {header: 'Status', cell: (row: Order) => `${row.statusName}`},
    {
      header: 'Voucher Code', cell: (row: Order) => {
        if (row.voucherCode != null) {
          return row.voucherCode;
        }
        return '-';
      }
    },

    {
      header: 'Ident Txn ID',
      cell: (row: Order) => `${(row.webIdTransaction || ({} as WebIdTransaction)).id || 'No Ident'}`
    },
    {
      header: 'Ident Status',
      cell: (row: Order) => `${IdentStatus[(row.webIdTransaction || ({} as WebIdTransaction)).status] || 'No Ident'}`
    },

  ];

  reorderFields = [
    { header: 'Reordered Card', icon: (row: Order) => 'visibility', link: (row: Order) => '../../cards/' + (row.reorderedCard?.id || ''), cell: (row: Order) => `${row.reorderedCard?.token}` } as ContentRowField<Order>,
    { header: 'Reorder Reason', cell: (row: Order) => {
        switch (row.reorderReason) {
          case CardReorderReason.LostOrStolen:
            return 'Lost or Stolen';
          case CardReorderReason.CardNotArrived:
            return 'Not arrived';
          case CardReorderReason.Expired:
            return 'Card has Expired';
        }
      } } as ContentRowField<Order>,
    { header: 'Reorder Comment', cell: (row: Order) => `${row.reorderedCard?.reorderComment}` } as ContentRowField<Order>,

  ] as ContentRowField<Order>[];

  cancellationFields = [
    {header: 'Cancellation reason', cell: (row: Order) => `${row.cancellationReasonName}`},
    {header: 'Cancellation comment', cell: (row: Order) => `${row.cancellationComment}`},
    // { header: "Cancellation comment", cell: (row: Order) => `${row.cancellationComment}` },
    {header: 'Cancellation date', cell: (row: Order) => `${toDateTimeString(row.cancellationDate) || ''}`},

  ];

  cancellationExtraFields = [
    {header: 'User Cancellation reason', cell: (row: Order) => `${row.userCancellationReasonName}`},
    {
      header: 'User Cancellation comment', cell: (row: Order) => {

        if (row.cancellationComment == null) {
          return '-';
        } else {
          row.cancellationComment;
        }

      }
    },
  ];


  invoiceFields = [
    // { header: "Code", cell: (row: Invoice) => `${row.code}` },
    {header: 'Annual Fee', cell: (row: Invoice) => `${row.annualFeeAtCreation.formatMoneyEuro()}`},
    {header: 'VAT Rate', cell: (row: Invoice) => `${row.vatRateAtCreation}`},
    {header: 'Bill amount', cell: (row: Invoice) => `${row.billAmount.formatMoneyEuro()}`},
    {header: 'Paid amount', cell: (row: Invoice) => `${row.paidAmount.formatMoneyEuro()}`},
    {header: 'Creation Date', cell: (row: Invoice) => `${toDateTimeString(row.creationDate)}`},
    {header: 'Orders count', cell: (row: Invoice) => `${row.voucherOrderId != null ? 1 : row.ordersCount}`},
    {header: 'Product', cell: (row: Invoice) => `${row.productName}`},
    // { header: "Company", cell: (row: Invoice) => `${row.productCompanyName}` },
    {header: 'Outstanding', cell: (row: Invoice) => `${row.outstandingAmount.formatMoneyEuro()}`},

    {
      header: 'Voucher code', cell: (row: Invoice) => {
        if (row.firstOrder && row.firstOrder.voucherCode) {
          return row.firstOrder.voucherCode;
        }
        return '-';
      }
    },
    {
      header: 'Partner price',
      cell: (row: Invoice) => `${row.partnerPrice != null ? row.partnerPrice.formatMoneyEuro() : '-'}`
    },
    // { header: "Total", cell: (row: Invoice) => `${row.partnerPrice + row.annualFeeAtCreation}` },
    {header: 'Invoice issuer', cell: (row: Invoice) => `${row.invoicingCompany}`},
    // { header: "IBAN/BIC", cell: (row: Invoice) => `${row.iban} / ${row.bic}` },
    {
      header: 'Payment', cell: (row: Invoice) => {

        let ret = 'unknown';

        if (row.paymentType) {
          if (this.types[row.paymentType]) {
            ret = this.types[row.paymentType];
          }
        }

        return ret;
      }
    },
  ];



  cardFields = [
    {
      header: 'Card Token',
      link: (row) => '../../cards/' + row.id,
      cell: (row) => {
        return `${row.card.token}`;
      },
      copyCellActive: (row) => true,
      copyCellContent: (row) => row.card.token,
    },
    {
      header: 'Primary Card',
      link: (row) => row.card.primaryCardId ? '../../cards/' + row.card.primaryCardId : null,
      cell: (row) => row.card.primaryCardId ? `${row.card.primaryToken}` : '(This is a primary card)',
      copyCellActive: (row) => !!row.card.primaryCardId
    },
    {
      header: 'Status',
      cell: (row) => {
        let t = `${this.gpsCardStatusHelper.getIcon(row.gpsCardStatusCached)} ${this.gpsCardStatusHelper.getText(row.gpsCardStatusCached)}`

        if ( row.card.autoCloseDate )
          t += " (close " + this.datePipe.transform(row.card.autoCloseDate, DateFormats.DisplayDate) + ')'

        return t;
      }
    },
    {
      header: 'Display Name',
      cell: row => row.card.displayName ? `${row.card.displayName}` : '',
      cellBackgroundColor: row => row.card.displayColor ? `#${row.card.displayColor}` : null,
      cellPadding: row=> 3,
      cellBorderRadius: row => 3,
    },
    {
      header: 'Last 4',
      cell: (row) => row.card.maskedPAN ? `${row.card.maskedPAN.substring(12)}` : 'unknown',
    },

    {header: 'Creation date', cell: (row) => `${toDateTimeString(row.card.creationDate) || ''}`},
    {header: 'Last known balance', cell: (row) => `${row.lastKnownAvailableBalance ?? '-'}`},
    {header: 'Cashback payable', cell: (row) => `${row.cashbackSummary?.payableAmount ?? '-'}`},
    {header: 'Shipping date', cell: (row) => `${toDateString(row.card.shippedDate) || ''}`},
    {
      header: 'Order cancellation date', cell: (row: CustomerOverviewCardContainer) => {
        if ( row == null ) {
          return '';
        }

        if ( row.card.orderCancellationDate != null ) {

          if (row.card.creationDate != null) {
            const cancellationDate = new Date(row.card.orderCancellationDate);
            const createDate = new Date(row.card.creationDate);

            const dontAllowCancellationDate = new Date(createDate);
            dontAllowCancellationDate.setDate(createDate.getDate() + 21);
            // console.log("d: " + dontAllowCancellationDate);

            if (cancellationDate <= dontAllowCancellationDate) {
              return toDateString(row.card.orderCancellationDate) + ' (revocation)';
            } else {
              return toDateString(row.card.orderCancellationDate) + ' (cancellation)';
            }
          }

        } else {
          return '';
        }
      }
    },
    {header: 'Activation date', cell: (row: CustomerOverviewCardContainer) => `${toDateTimeString(row.card.activationDate) || ''}`},
    {header: 'Order date', cell: (row: CustomerOverviewCardContainer) => `${toDateString(row.card.orderDate) || ''}`},
    { header: 'Next Annual Fee', cell: (row: CustomerOverviewCardContainer) => `${toDateString(row.card.nextAnnualFeeDateDisplayed || row.card.nextAnnualFeeDate) || ''}` } as ContentRowField<CustomerOverviewCardContainer>,

    { header: 'Has Annual Fee Promotion', cell: (row: CustomerOverviewCardContainer) => `${row.card.hasPromotionalAnnualFee ? 'YES':'NO'}`

      , iconColor: (row: CustomerOverviewCardContainer) => row.card.hasPromotionalAnnualFee ? 'forestgreen':'red'
      , icon: (row: CustomerOverviewCardContainer) => row.card.hasPromotionalAnnualFee ? 'check': 'close'

    } as ContentRowField<CustomerOverviewCardContainer>,
    { header: 'Annual Fee Promotion', cell: (row: CustomerOverviewCardContainer) => `${row.card.promotionalAnnualFeeReason || '-'}`

    } as ContentRowField<CustomerOverviewCardContainer>,
    { header: 'Annual Fee Promotion until', cell: (row: CustomerOverviewCardContainer) => `${toDateString(row.card.promotionalAnnualFeeEndDate) || ''}` } as ContentRowField<CustomerOverviewCardContainer>,

    {header: 'Order', link: (row: CustomerOverviewCardContainer) => '../../orders/' + row.card.orderId, cell: (row: CustomerOverviewCardContainer) => `${row.card.orderId || ''}`},

    // MS removed this on 2023-02-24
    /*{header: "SEPA Count", link: (row: CustomerOverviewCardContainer) => this.currentUserIsPartner() ? null : "../../loads/sepas", queryParams: (row: CustomerOverviewCardContainer) => ({search: row.card.token}), cell: (row: CustomerOverviewCardContainer) => `${row.card.sepas.length || 0}`},
    {header: "SOFORT Count", link: (row: CustomerOverviewCardContainer) => this.currentUserIsPartner() ? null : "../../loads/soforts", queryParams: (row: CustomerOverviewCardContainer) => ({search: row.card.token}), cell: (row: CustomerOverviewCardContainer) => `${row.card.soforts.length || 0}`},*/

    {header: 'PAN', cell: (row: CustomerOverviewCardContainer) => `${row.card.maskedPAN || '(unknown)'}`},
    {header: 'Card Type', cell: (row: CustomerOverviewCardContainer) => `${row.card.cardTypeName || '(unknown)'}`},
    {header: 'Migrated', cell: (row: CustomerOverviewCardContainer) => `${row.card.isMigrated ? 'Yes' : 'No'}`},
    {header: 'Migrated from', cell: (row: CustomerOverviewCardContainer) => `${row.card.migratedFromToken || ''}`},
    {
      header: 'Payment Reminders',
      cell: (row: CustomerOverviewCardContainer) => `${row.card.order.paymentEmailReminders && row.card.order.paymentEmailReminders.length || 0}`
    },
    {header: 'Invoice', link: (row: CustomerOverviewCardContainer) => '../../invoices/' + row.card.order.invoiceId, cell: (row: CustomerOverviewCardContainer) => `${row.card.order.invoiceNumber || ''}`},

    {
      header: 'Cashback Override',
      cell: (row: CustomerOverviewCardContainer) => `${row.card.cashbackFactorOverride ? ((row.card.cashbackFactorOverride*100).toFixed(2) + '%') : "(none)"}`
    },
    {
      header: 'Cashback Override Until',
      cell: (row: CustomerOverviewCardContainer) => `${row.card.cashbackFactorOverrideExpiry ? this.datePipe.transform(row.card.cashbackFactorOverrideExpiry, DateFormats.DisplayDate) : "(none)"}`
    },

    // { header: "Payment Reminders" , cell: (row: Card) => "<a payment-reminders" + row.token + " " + `${ row.order.paymentEmailReminders.length || 0 }` },
    // DO NOT DELETE
    // { header: "Rec ID", cell: (row: Card) => `${row.recId || ""}` },
    // { header: "Status", cell: (row: Card) => `${row.statusName || ""}` },
    // { header: "Comment", cell: (row: Card) => `${row.comment || ""}` },
    // { header: "Pull date", cell: ( row: Card ) => `${ toDateTimeString( row.pullDate ) || "" }` },
  ] as ContentRowField<CustomerOverviewCardContainer>[];

  userIsPartnerAndCardProcessorEnquiryEnabled = false;

  loadHistory: BankTransferLoad[];
  loadHistorySums: AmountAndCurrencyContainer[];
  loadHistoryPendingSums: AmountAndCurrencyContainer[];

  inboundC2CHistorySums: AmountAndCurrencyContainer[];

  isDocsResendHidden = true;

  isDocsResendUploadLinkDisabled = true;

  docsInvoiceId;
  docInvoice;

  smsForm: FormGroup;
  pushForm: FormGroup;
  pushDataForm: FormGroup;


  isSmsSending = false;
  isPushSending = false;
  isPushDataSending = false;

  smsEmailLogs: CustomerEmailLogDto[];
  invoices: Invoice[];

  activeRiskAssessmentInquiry: RiskAssementInquiry = null;
  newRiskAssessmentForm: FormGroup;


  @ViewChild(MatPaginator, {static: false}) paginatorStatement: MatPaginator;

  isStatementLoading = false;
  isCardInfoLoading = false;
  isCardholderDetailsLoading = false;

  displayedStatementColumns: string[] = ['direction', 'transactionDate', 'description', 'amountCurrency', 'fees', 'statusDescription'];


  fieldsCardholderDetails = [
    {header: 'Sex', cell: (row: CardHolderDetails) => `${row.sex}`},
    {header: 'Firstname', cell: (row: CardHolderDetails) => `${row.firstName}`},
    {header: 'Lastname', cell: (row: CardHolderDetails) => `${row.lastName}`},
    {header: 'E-Mail', cell: (row: CardHolderDetails) => `${row.email}`},
    {header: 'Date of birth', cell: (row: CardHolderDetails) => `${toDateString(row.dateOfBirth) || ''}`},
    {header: 'Phone', cell: (row: CardHolderDetails) => `${formatPhone(row.phone)}`},
    {header: 'Mobile', cellFlag: (row: CardHolderDetails) => phoneToCountry(row.mobile), cell: (row: CardHolderDetails) => `${row.mobile}`},
    {header: 'Address Line 1', cell: (row: CardHolderDetails) => `${row.addrl1}`},
    {header: 'Address Line 2', cell: (row: CardHolderDetails) => `${row.addrl2}`},
    {header: 'Zip City', cell: (row: CardHolderDetails) => `${row.postCode} ${row.city}`},
  ];

  fieldsIban = [
    {header: 'Currency', cell: (row: CustomerIban) => `${row.currency}`},
    {header: 'IBAN', cell: (row: CustomerIban) => `${row.iban}`},
    {header: 'BIC', cell: (row: CustomerIban) => `${row.bic}`},
    {header: 'Status', cell: (row: CustomerIban) => `${row.statusId}`},

  ];

  fieldsCardInfo = [
    {header: 'Status', cell: (row: CardInfo) => `${GpsCardStatusHelper.getIcon1(row.statCode)} ${GpsCardStatusHelper.getText1(row.statCode)}`},
    {header: 'PAN', cell: (row: CardInfo) => `${row.maskedPAN}`},
    {header: 'Embossed name', cell: (row: CardInfo) => `${row.embossedName}`},
    {header: 'Creation', cell: (row: CardInfo) => `${toDateString(row.creationDate) || ''}`},
    {header: 'Expiry', cell: (row: CardInfo) => `${toDateString(row.expiryDate) || ''}`},
    {header: 'Avail. balance', cell: (row: CardInfo) => `${row.currency} ${row.availableBalance}`},
    {header: 'Blocked amount', cell: (row: CardInfo) => `${row.currency} ${row.blockedAmount}`},
    // { header: "Currency", cell: (row: CardInfo) => `${row.currency}` },
    {header: 'Product', cell: (row: CardInfo) => `${row.product}`},
    {header: 'Limit group', cell: (row: CardInfo) => `${row.limitGroupDesc}`},


  ];



  // Upload
  files: File[] = [];
  filesSof: File[] = [];
  filesAddressConfirmation: File[] = [];
  disabled = false;
  showUploadError = false;
  isUploading = false;
  lastDocLinkToken = null;
  lastSofGenericLinkToken = null;
  lastAddressConfirmationLinkToken = null;


  disableRiskAssBtn = false;
  isLoadingInboundCardToCardTransfers = false;

  // / for card invoice edit
  gpsCardStatusHelper = GpsCardStatusHelper;

  ngOnInit() {

    this.companyService.getAll().subscribe(x => {
      this.companies = x.data;
    });


    this.countryService.getMany().subscribe(result => {
      this.countries = result.data;
    });

    this.customerOverviewFilters = JSON.parse(sessionStorage.getItem('customerOverviewTable')) ?? {};

    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.customerId = (idParam);
      this.loadCustomerData();
    });


    this.productService.getAll().subscribe(result => {
      this.products = result.data;
    });

    this.countryService.getMany().subscribe(result => {
      this.countiries = result.data;
    });


  }

  loadCustomerData() {
    this.clearData();

    this.customer = null;
    this.customerRisk = null;
    this.orders = [];
    this.cardContainers = [];
    this.comments = null;

    this.showCustomerEdit = false;



    this.getSolrCustomer();

    this.refreshCustomer();

    if ( !this.currentUserIsIssuerExternal() ) {
      this.idvCustomersService.getLastLinkToken(this.customerId, 2).subscribe(data => {
        this.lastDocLinkToken = data;
      });
      this.idvCustomersService.getLastLinkToken(this.customerId, 4).subscribe(data => {
        this.lastSofGenericLinkToken = data;
      });
      this.loadComments();
    }




    if (this.currentUserIsPartner()) {

      this.companyService.getCardProcessorEnquiryEnabledForLoggedInPartner().subscribe(result => {
            this.userIsPartnerAndCardProcessorEnquiryEnabled = result;
          },
          error => {
            this.userIsPartnerAndCardProcessorEnquiryEnabled = false;
          });
    }

    this.isWebIdDownloadVisible = this.roleService.hasRoles(['admin', 'compliance']);
    // this.isWebIdDownloadVisible = true;

  }

  getEmailIconColor(row: Customer): string|boolean {
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable && row.emailRejectedCount >= 3) {
      return '#ff0000';
    }
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable) {
      return '#ff9900';
    }

    if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
      return '#008400';
    }

    return false;
  }

  getEmailIcon(row: Customer): string|boolean {
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable ) {
      return 'front_hand';
    }
    if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
      return 'mark_email_read';
    }
    return 'email';

  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsAdminOrManagerOrAgent(): boolean {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }

  currentUserIsComplianceOrManagerOrAgent(): boolean {
    return this.roleService.hasRoles(['manager', 'agent', 'compliance']);
  }

  currentUserIsIssuerExternal(): boolean {
    return this.roleService.hasRoles(['issuer_external']);
  }


  // for customer edit

  onCustomerEditFormSubmit() {

    this.isUpdatingCustomer = true;

    const c = this.customerForm.getRawValue();
    this.initSmsForm(c);
    this.initPushForm(c);
    c.cards = [];
    c.orders = [];

    this.customersService.update(c)
      .subscribe(res => {
        // this.returnBack();
        this.isUpdatingCustomer = false;
        this.refreshCustomer();
        this.showCustomerEdit = false;
      }, error => {
        this.isUpdatingCustomer = false;
      });


  }


  onShowCustomerEdit(show: boolean) {

    if (!show) {
      this.initCustomerEditForm(this.customer);
    }

    this.showCustomerEdit = show;
  }
  changeEmail() {

    if ( this.customer.isAnonymized ) {
      this._toastService.error("Customer is anonymized, cannot change email");
      return;
    }

    this.dialog.open(ChangeEmailDialogComponent).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof ChangeEmailModel) {

          dlgResult.customerId = this.customerId;

          this.customersService.changeEmail(dlgResult).subscribe(result => {

            this._toastService.success('E-Mail verification link sent.');

            /*this.snackBar.open("E-Mail verification link sent.", null, {
              duration: 5000,
              panelClass: ["app-mat-snack-bar"]
            });*/
          });

          this.refreshCustomer();


        }
      });
  }

  changePhone() {

    if ( this.customer.isAnonymized ) {
      this._toastService.error("Customer is anonymized, cannot change phone");
      return;
    }

    this.dialog.open(ChangeCustomerPhoneDialogComponent, {
      data: {
        customerId: this.customerId,
      },
    }).afterClosed()
      .subscribe(dlgResult => {

        if (dlgResult instanceof ChangePhoneModel) {
          this.refreshCustomer();
        }
      });
  }

  initCustomerEditForm(customer: Customer) {
    this.customerForm = this.formBuilder.group(customer);
    if (!this.currentUserIsAdminOrComplianceOrFinanceManagerOrManager()) {
      this.customerForm.controls['address'].disable();
      this.customerForm.controls['city'].disable();
      this.customerForm.controls['countryIsoCode'].disable();
      this.customerForm.controls['zipCode'].disable();
    }
  }

  // /for customer edit

  // for order edit

  initOrderEditForm(item: Order) {
    return this.formBuilder.group(item);
  }

  getOrderItemById(id: number) {
    const found = this.orders.find(this.findIndexToUpdate, id);
    return found;
  }



  onShowOrderEdit(id: number, isVisible: boolean) {
    const found = this.orders.find(this.findIndexToUpdate, id);
    found.editVisible = isVisible;

    if (!isVisible) {
      found.editForm = this.initOrderEditForm(found.order);
    }

  }


  onOrderEditFormSubmit(id: number) {

    const found = this.orders.find(this.findIndexToUpdate, id);

    this.ordersService.update(found.editForm.value)
      .subscribe(res => {
        this.onShowOrderEdit(id, false);
        this.refreshCustomer();
      });

  }

  editEnabled() {
    return this.currentUserIsAdminOrComplianceOrFinanceManagerOrManager();
  }

  currentUserIsAdminOrCompliance(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance']);
  }

  currentUserIsSupportManager(): boolean {
    return this.roleService.hasRoles(['manager']);
  }

  currentUserIsAdminOrComplianceOrFinanceManagerOrManager(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance', 'finance_manager', 'manager']);
  }

  currentUserIsManager(): boolean {
    return this.roleService.hasRoles(['manager']);
  }

  allowEditOrder(order) {
    return order && order.status < OrderStatus.Shipped;
  }


  cancelOrderDisabled(order) {
    return order && (order.status == OrderStatus.Activated || order.status == OrderStatus.Cancelled);
  }

  CancelOrderDisabled(order: Order) {

    if (order) {

      let disabled = true;
      disabled = order.status == OrderStatus.Activated || order.status == OrderStatus.Cancelled;

      if (!disabled) {
        if (order.card == null) {
          disabled = false;
        }

        if (order.card != null && order.card.creationDate != null) {
          const now = new Date();
          const createdate = new Date(order.card.creationDate);
          // console.log(createdate);
          // return true;

          const dontAllowCancellationDate = new Date(createdate);
          dontAllowCancellationDate.setDate(createdate.getDate() + 21);
          // console.log("d: " + dontAllowCancellationDate);

          if (now <= dontAllowCancellationDate) {
            disabled = false;
          } else {
            disabled = true;
          }
        }

        return disabled;

      }

    } else {
      return true;
    }

    return order && (order.status == OrderStatus.Activated || order.status == OrderStatus.Cancelled);
  }

  CloseCardDisabled(card: Card) {

    if ( card.status == 6)
      return true;

    const order = card.order;

    if ( !order )
      return true;

    // but allow if the order is already cancelled and the card is not
    if ( order.status == OrderStatus.Cancelled)
      return false;


    if (card.creationDate != null) {
      const now = new Date();
      const createdate = new Date(card.creationDate);
      // console.log(createdate);
      // return true;

      const dontAllowCancellationDate = new Date(createdate);
      dontAllowCancellationDate.setDate(createdate.getDate() + 21);
      // console.log("d: " + dontAllowCancellationDate);

      if (now <= dontAllowCancellationDate) {
        return false;
      } else {
        return true;
      }
    }


    return order.status == OrderStatus.Activated;
  }

  cancelOrder(id: number) {

    const foundElement = this.orders.find(this.findIndexToUpdate, id);

    if (this.currentUserIsPartner()) {

      this.dialog.open(OrderCancelDialogComponent, {data: {orderId: id, reasonId: 4}}).afterClosed()
        .subscribe(dlgResult => {
          if (dlgResult instanceof OrderCancellationModel) {
            this.ordersService.cancelOrder(dlgResult).subscribe(result => {

              this.refreshCustomer();

              this._toastService.info(
                'Order has been cancelled'
              );

              /*this.snackBar.open("Order has been cancelled", null, {
                duration: 5000,
                panelClass: ["app-mat-snack-bar"]
              });*/
            });
          }
        });

    } else {
      this.dialog.open(OrderCancelDialogComponent, {data: {orderId: id}}).afterClosed()
        .subscribe(dlgResult => {
          if (dlgResult instanceof OrderCancellationModel) {
            this.ordersService.cancelOrder(dlgResult).subscribe(result => {

              this.refreshCustomer();


              this._toastService.info('Order has been cancelled');

              /*this.snackBar.open("Order has been cancelled", null, {
                duration: 5000,
                panelClass: ["app-mat-snack-bar"]
              });*/
            });
          }
        });
    }


  }

  // /for order edit


  // for card invoice edit

  getCardItemById(id: number) {
    const found = this.cardContainers.find(this.findIndexToUpdate, id);
    return found;
  }

  initInvoiceEditForm(item: Invoice) {
    return this.formBuilder.group(item);
  }


  showCardActions() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }

  displayAddCardToCashbackGroupDialog(card: Card) {
    this.dialog.open(AddCardToCashbackGroupDialogComponent, {
      data: {
        card,
      }
    })
      .afterClosed()
      .subscribe((result: CashbackGroupMembership) => {

        const cashbackGroupId = result.cashbackGroupId;
        const cardId = result.cardId;

        if ( !cashbackGroupId) {
          this._toastService.warn('Aborted');
          return;
        }

        if ( !cardId) {
          this._toastService.warn('Aborted');
          return;
        }

        const groupMembership = new CashbackGroupMembership();
        groupMembership.cashbackGroupId = cashbackGroupId;
        groupMembership.cardId = cardId;

        this.cashbackGroupsService.addCardToCashbackGroup(cardId, cashbackGroupId).subscribe(data => {
          this._toastService.success('Card ' + card.token + ' was added to cashback group');

          this.refreshCustomer();

        }, err => {

          this._toastService.error(err.error.message || err.message || err.error || err);
        });
      });
  }

  reorderCard(id: number) {
    this.dialog.open(CardReorderDialogComponent).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CardReorderModel) {
          this.isReorderingCard = true;
          dlgResult.id = id;
          this.ordersService.reorderCard(dlgResult).subscribe(result => {
            this.isReorderingCard = false;
            if ( result.isError ) {
              this._toastService.error('Error re-ordering: ' + result.errorMessage);
            } else if ( result.needsConfirmation) {
              this._toastService.warn('Re-Order of this card needs confirmation by compliance');
              this.refreshCustomer();
            } else {
              this._toastService.success('Card has been reordered');
              this.refreshCustomer();
            }
          });


        }
      });
  }

  replaceCard(id: number) {
    this.dialog.open(CardReorderDialogComponent).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CardReorderModel) {
          this.isReorderingCard = true;
          dlgResult.id = id;
          this.ordersService.reorderCard(dlgResult).subscribe(result => {
            this.isReorderingCard = false;
            if ( result.isError ) {
              this._toastService.error('Error re-ordering: ' + result.errorMessage);
            } else if ( result.needsConfirmation) {
              this._toastService.warn('Re-Order of this card needs confirmation by compliance');
              this.refreshCustomer();
            } else {
              this._toastService.success('Card has been reordered');
              this.refreshCustomer();
            }
          });


        }
      });
  }

  extendCard(publicToken: string) {
    this.dialog.open(CardExtensionDialogComponent).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CardExtensionModel) {
          dlgResult.publicToken = publicToken;
          this.isExtendingCard = true;
          this.cardsService.extendCard(dlgResult.publicToken).subscribe(result => {

            console.log(result);
            this._toastService.success('Card has been extended');
            this.refreshCustomer();
            this.isExtendingCard = false;

          }, err => {
            this._toastService.error(err.error.message || err.error || err.message || err);
            this.isExtendingCard = false;
          });


        }
      });
  }

  issuePseudoCard(publicToken: string) {
    this.dialog.open(CardExtensionDialogComponent, {
      data: {
        publicToken,
        text: `Are you sure you want to issue card ${publicToken}?`,
        title: 'Issue card',
      }
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CardExtensionModel) {
          dlgResult.publicToken = publicToken;
          this.isIssuingPseudoCard = true;
          this.cardsService.issuePseudoCard(dlgResult.publicToken).subscribe(result => {

            console.log(result);
            this._toastService.success('Card has been issued, actual token is ' + result.newPublicToken);
            this.refreshCustomer();
            this.isIssuingPseudoCard = false;

          }, err => {
            this._toastService.error(err.error.message || err.error || err.message || err);
            this.isIssuingPseudoCard = false;
          });


        }
      });
  }

  queueCardForConversion(publicToken: string) {
    this.dialog.open(CardExtensionDialogComponent, {
      data: {
        publicToken,
        text: `Are you sure you want to convert card ${publicToken} to a physical card?`,
        title: 'Convert card',
      }
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CardExtensionModel) {
          dlgResult.publicToken = publicToken;
          this.isQueueingCardForConversion = true;
          this.cardsService.queueForConversion(dlgResult.publicToken).subscribe(result => {

            console.log(result);
            this._toastService.success('Card has been queued for conversion');
            this.refreshCustomer();
            this.isQueueingCardForConversion = false;

          }, err => {
            this._toastService.error(err.error.message || err.error || err.message || err);
            this.isQueueingCardForConversion = false;
          });


        }
      });
  }

  isChangeAddressDisabled(customer: Customer) {
    if (!customer) {
      return true;
    }
    if (customer.archived) {
      return true;
    }

    if (!this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner', 'compliance'])) {
      return true;
    }

    return false;
  }

  isIdentLinkDisabled() {
    // , "manager", "agent", "compliance"
    if (!this.roleService.hasRoles(['admin']) && !this.roleService.hasRoles(['compliance'])) {
      return true;
    }

    return false;
  }

  isDocsDisabled(customer: Customer) {
    return true;
  }

  isRequestSofDisabled(customer: Customer) {
    if (!customer) {
      return true;
    }
    if (customer.archived) {
      return true;
    }

    if (!this.roleService.hasRoles(['admin', 'manager', 'partner', 'partner_support', 'agent', 'compliance'])) {
      return true;
    }


    return false;
  }

  isRequestPoaDisabled(customer: Customer) {
    if (!customer) {
      return true;
    }
    if (customer.archived) {
      return true;
    }

    if (!this.roleService.hasRoles(['admin', 'manager', 'partner', 'partner_support', 'agent', 'compliance'])) {
      return true;
    }


    return false;
  }

  isResendWebidDisabled(order: Order) {

    if (order.archived) {
      return true;
    }

    if (order.status === OrderStatus.Cancelled) {
      return true;
    }

    if (!this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner', 'compliance'])) {
      return true;
    }

    if (order.webIdTransaction != null && order.webIdTransaction.status === IdentStatus.success) {
      return true;
    }

    return false;
  }

  sendChangeAddressLink(customer: Customer) {
    this.dialog.open(SendUploadLinkDialogComponent, {
      data: {
        email: customer.email,
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          dlgResult.customerId = customer.id;
          dlgResult.typeId = 3;

          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this._toastService.info('Change address Uploadlink sent.');
          });

          this.refreshCustomer();


        }
      });
  }

  sendIdentLink(customer: Customer) {
    // workaround: send to last order
    // TODO remove this once customer only ident links do work
    if ( this.orders.length > 0 ) {
      this.resendWebIdLink(this.orders[0].order);
      return;
    }

    this.requestCustomerIdent();

  }

  // search: sdkjfhsdlkufhgsdf
  createInternalDocsLink(customer) {

    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Upload Docs', text: 'Are you sure you want to upload DOC files to this customer?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          const model = new SendUploadLinkModel();
          model.customerId = customer.id;
          model.typeId = 2;
          model.email = null;
          model.isInternal = true;

          this.customersService.createInternalUploadLink(model).subscribe(result => {

            const data = {
              link: result.url,
              title: 'Internal uploadlink for Docs',
              // text: "Are you sure you want to send a new upload link (incl. invoice)? Other active links will be deactivated!"
              text: 'Click the link below to upload files.',

            };

            this.dialog.open(ShowDialogWithLinkComponent, {
              data
            }).afterClosed()
              .subscribe(dlgResult => {
                this.refreshCustomer();
              });

            this.snackBar.open('internal uploadlink created.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });
        }
      });




  }



  sendDocsLink(customer: Customer) {

    const data = {
      email: customer.email,
      title: 'Send an uploadlink for Docs',
      // text: "Are you sure you want to send a new upload link (incl. invoice)? Other active links will be deactivated!"
      text: 'Are you sure you want to send a new upload link? Other active links will be deactivated!'
    };


    this.dialog.open(SendUploadLinkDialogComponent, {
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          dlgResult.customerId = customer.id;
          dlgResult.typeId = 2;

          // Anton 26.09.2021 doc link for free
          /*
          this.customersService.sendDocPaymentLink(dlgResult).subscribe(result => {
            this.snackBar.open("Paymentlink sent.", null, {
              duration: 5000,
              panelClass: ["app-mat-snack-bar"]
            });
            this.refreshResendDocButton();
          });
          */

          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this._toastService.info('Docs Uploadlink sent.');
          });


          this.refreshCustomer();
        }
      });
  }

  sendSofGenericLink(customer: Customer) {

    const data = {
      email: customer.email,
      title: 'Send an uploadlink for SOF generic',
      // text: "Are you sure you want to send a new upload link (incl. invoice)? Other active links will be deactivated!"
      text: 'Are you sure you want to send a new upload link? Other active links will be deactivated!'
    };


    this.dialog.open(SendUploadLinkDialogComponent, {
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          const typeId = 4; // 4 = SOF generic
          dlgResult.customerId = customer.id;
          dlgResult.typeId = typeId;

          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.idvCustomersService.getLastLinkToken(this.customerId, typeId).subscribe(data => {
              this.lastSofGenericLinkToken = data;
            });
            this._toastService.info('SOF Generic Uploadlink sent.');
          });


          this.refreshCustomer();
        }
      });
  }


  // proof of address
  sendPoaLink(customer: Customer) {

    const data = {
      email: customer.email,
      title: 'Send an uploadlink for POA',
      text: 'Are you sure you want to send a new upload link? Other active links will be deactivated!'
    };


    this.dialog.open(SendUploadLinkDialogComponent, {
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          const typeId = 6; // 6 = POA
          dlgResult.customerId = customer.id;
          dlgResult.typeId = typeId;

          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.idvCustomersService.getLastLinkToken(this.customerId, typeId).subscribe(data => {
              this.lastAddressConfirmationLinkToken = data;
            });
            this._toastService.info('POA Uploadlink sent.');
          });


          this.refreshCustomer();
        }
      });
  }


  refreshDocsResendUploadLinkDisabled() {


    if (!this.roleService.hasRoles(['admin', 'manager', 'partner', 'compliance'])) {
      this.isDocsResendUploadLinkDisabled = true;
      return;
    }

    if (this.docInvoice != null && this.docInvoice.billAmount > this.docInvoice.paidAmount) {
      this.isDocsResendUploadLinkDisabled = true;
      return;
    }

    this.isDocsResendUploadLinkDisabled = false;
  }

  resendDocsPaymentLink(customer: Customer) {
    const data = {
      email: customer.email,
      title: 'Resend payment link for Docs ',
      text: 'Are you sure you want to resend the paymenlink?'
    };

    this.dialog.open(SendUploadLinkDialogComponent, {
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {

          this.customersService.resendDocPaymentLink(this.docsInvoiceId).subscribe(result => {
            this.snackBar.open('Payment link sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

        }
      });
  }

  resendDocsInvoice(customer: Customer) {
    const data = {
      email: customer.email,
      title: 'Resend invoice for Docs ',
      text: 'Are you sure you want to resend doc invoice?'
    };

    this.dialog.open(SendUploadLinkDialogComponent, {
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {

          this.customersService.resendDocInvoice(this.docsInvoiceId).subscribe(result => {
            this.snackBar.open('Invoice sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

        }
      });
  }

  resendDocsLink(customer: Customer) {

    const data = {
      email: customer.email,
      title: 'Resend uploadlink for Docs ' + this.docPaidText,
      text: 'Are you sure you want to resend the existing upload link?'
    };

    this.dialog.open(SendUploadLinkDialogComponent, {
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {

          this.customersService.resendDocUploadLink(this.docsInvoiceId).subscribe(result => {
            this.snackBar.open('Link sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });
          /*
          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.snackBar.open("Uploadlink sent.", null, {
              duration: 5000,
              panelClass: ["app-mat-snack-bar"]
            });
          });
          */

          this.refreshCustomer();
        }
      });
  }

  resendWebIdLink(order: Order) {

    this.dialog.open(ResendWebidDialogComponent, {
      data: {
        email: order.email,
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof ResendWebidModel) {
          dlgResult.id = order.id;

          this.ordersService.resendWebidLink(dlgResult).subscribe(result => {
            this._toastService.info('Ident link recreated and e-mail sent.');
          });

          this.refreshCustomer();


        }
      });
  }

  requestCustomerIdent() {



    this.dialog.open(ResendWebidDialogComponent, {
      data: {
        email: this.customer.email,
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof ResendWebidModel) {
          dlgResult.id = this.customer.id;

          this.customersService.requestIdent(dlgResult).subscribe(result => {
            this._toastService.info('Customer Ident link recreated and e-mail sent.');
          });

          this.refreshCustomer();


        }
      });
  }

  syncMicroPaymentSessions(customerId: number) {

      this.customersService.syncMicroPaymentSessions(customerId)
        .subscribe(result => {
            this.showInfo('MicroPayment Transactions will be synchronized...');
            this.isLoadingBankTransferLoads = true;
            setTimeout(() => {
              this.getBankTransferLoads();
              this.isLoadingBankTransferLoads = true;
            }, 3000);

            setTimeout(() => {
              this.getBankTransferLoads();
            }, 10000);

          },
          err => {
            this.showError(err.error.message || err.error || err.message);
          });

  }


  closeCard(id: number) {

    const found = this.cardContainers.find(this.findIndexToUpdate, id);
    if (!found || this.CloseCardDisabled(found.card) || found.card.status === 6) {
      return;
    }

    const card = found.card;

    this.dialog.open(StatusChangeReasonDialogComponent, { data: {
      title: 'Close',
      subText: 'Please enter a reason to be shown on the card statement for the status change.',
      text: 'Are you sure you want to close card ' + card.token + '?',
        customReasonAllowed: true,
        selectableReasons: [

        ] } })
      .afterClosed()
      .subscribe(result => {
        if (result ) {
          this.cardsService.closeCard(card.token, result)
            .subscribe(result => {
              this.showSuccess('The card was closed');

              this.refreshCustomer();

            },
              err => {
 this.showError(err.error.message || err.error || err.message);
});

        } else {
          this.showWarning('The card was not closed, no reason specified');
        }
      });


  }

  unCloseCard(id: number) {

    const found = this.cardContainers.find(this.findIndexToUpdate, id);

    // 20240424 Victoria fragt Anton, ob Compliance auch unclosen dürfen
    // if ( !this.currentUserIsAdminOrCompliance()) {
    if ( !this.currentUserIsAdmin()) {
      this.dialog.open(ConfirmDialogComponent, { data: { title: 'No permission', text: 'You do not have permission to un-close a card' } });
      return;
    }

    const card = found.card;

    this.dialog.open(StatusChangeReasonDialogComponent, { data: {
      title: 'Un-Close',
        text: 'Are you sure you want to set card ' + card.token + ' back to active?',
        subText: 'Please enter a reason to be shown on the card statement for the status change.',
        selectableReasons: [],
        customReasonAllowed: true,  } })
      .afterClosed()
      .subscribe(result => {
        if (result ) {
          this.cardsService.unCloseCard(card.token, result)
            .subscribe(result => {
                this.showSuccess('The card is now active again');

                this.refreshCustomer();
                // FIXME here only the cards and the customer's object comments need to be reloaded
                //this.refreshCards();

              },
              err => {
 this.showError(err.error.message || err.error || err.message);
});

        } else {
          this.showWarning('The card was not un-closed, no reason specified');
        }
      });


  }


  onShowCardInvoiceEdit(card: Card, isVisible: boolean) {
    const found = this.cardContainers.find(this.findIndexToUpdate, card.id);
    found.editVisible = isVisible;

    if (!isVisible) {
      found.editForm = found.card.order.invoice ? this.initInvoiceEditForm(found.card.order.invoice) : null;
    }
  }

  onCardInvoiceEditSubmit(card: Card) {

    // id = cardid!!!!

    const found = this.cardContainers.find(this.findIndexToUpdate, card.id);

    found.editForm.value.orders = null;
    found.editForm.value.product = null;

    this.invoicesService.update(found.editForm.value)
      .subscribe(res => {
        this.onShowCardInvoiceEdit(card, false);
        this.refreshCustomer();
      });


  }


  onShowOrderInvoiceEdit(order: Order, isVisible: boolean) {
    const found = this.orders.find(this.findIndexToUpdate, order.id);
    found.invoiceEditVisible = isVisible;

    if (!isVisible) {
      found.invoiceEditForm = found.invoice ? this.initInvoiceEditForm(found.invoice) : null;
    }
  }

  onOrderInvoiceEditSubmit(order: Order) {

    // id = orderid!!!!

    const found = this.orders.find(this.findIndexToUpdate, order.id);

    found.editForm.value.orders = null;
    found.editForm.value.product = null;

    this.invoicesService.update(found.invoiceEditForm.value)
      .subscribe(res => {
        this.onShowOrderInvoiceEdit(order, false);
        this.refreshCustomer();
      });


  }


  showInfo(msg: string) {
    this._toastService.info(msg);
  }

  showWarning(msg: string) {
    this._toastService.warn(msg);
  }

  showSuccess(msg: string) {
    this._toastService.success(msg);
  }

  showError(msg: string) {
    this._toastService.error(msg);
  }

  returnBack() {
    this.location.back();
  }

  findIndexToUpdate(newItem) {
    return newItem.id === this;
  }

  downloadFile(fileId: number) {
    this.customersService.getFile(fileId).subscribe(
      result => {
        FileHelper.saveFile(result);
      },
      err =>
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        })
    );
  }

  refreshResendDocButton() {
    if ( this.currentUserIsIssuerExternal() ) {
return;
}

    this.customersService.getIsAnyDocUploadActive(this.customerId).subscribe(data => {

      this.docPaidText = '';

      if (data != null) {
        this.isDocsResendHidden = false;
        if (data.docInvoice != null) {

          this.docsInvoiceId = data.docInvoice.id;
          this.docInvoice = data.docInvoice;
          if (data.docInvoice.billAmount <= data.docInvoice.paidAmount) {
            this.docPaidText = '(paid)';
          } else {
            this.docPaidText = '(NOT paid)';
          }

        }


      } else {

        // check if inactive paid link exists
        this.customersService.getIsAnyDocUploadInvoicePaid(this.customerId).subscribe(data => {

          if (data != null && data.docInvoice != null) {
            this.isDocsResendHidden = false;
            this.docsInvoiceId = data.docInvoice.id;
            this.docInvoice = data.docInvoice;
            if (data.docInvoice.billAmount <= data.docInvoice.paidAmount) {
              this.docPaidText = '(paid)';
            } else {
              this.docPaidText = '(NOT paid)';
            }
          } else {
            this.isDocsResendHidden = true;
            this.docPaidText = '';
          }
        });

        this.refreshDocsResendUploadLinkDisabled();

      }

      this.refreshDocsResendUploadLinkDisabled();

    });
  }

  initSmsForm(customer: Customer) {
    const message = this.smsForm != null && this.smsForm.value ? this.smsForm.value.message : '';

    this.smsForm = this.formBuilder.group({
      mobile: customer.phone != null ? customer.phone.toString() : null,
      message,
      customerId: customer.id
    });
  }

  initPushForm(customer: Customer) {
    this.pushForm = this.formBuilder.group({
      isSilent: false,
      notificationTitle: '',
      notificationText: '',
      severity: 'info',
      bodyTitle: '',
      bodyText: '',
      customerId: customer.id,
      dataString: '',
      action: '',
      actionParameter: '',
    });
  }

  initPushDataForm(customer: Customer) {
    this.pushDataForm = this.formBuilder.group({
      reloadCards: false,
      reloadAccount: false,
      reloadPendingLoads: false,
      reloadNextSteps: false,
      customerId: customer.id,

    });
  }

  getCurrentRiskLevel() {
    if ( this.customer ) {
      let lvl = 0;
      if ( this.customer.riskLevelOverride != null ) {
        lvl = this.customer.riskLevelOverride;
      } else {
        lvl = this.customer.riskLevel;
      }

      if ( lvl == 0 ) {
        return 'low';
      } else if ( lvl == 1 ) {
        return 'medium';
      } else if ( lvl == 2 ) {
        return 'high';
      }

    }

    return '-';

  }

  getIdentLevelClass() {
    if ( this.customer ) {
      switch (this.customer.identLevel) {
        case IdentLevel.Sdd:
          return 'ident-level-1';
        case IdentLevel.Fdd:
          return 'ident-level-2';
        case IdentLevel.Edd:
          return 'ident-level-3';
      }

      return 'ident-level-0';
    }
    return '';
  }
  getCurrentIdentLevel() {
    if ( this.customer ) {
      switch (this.customer.identLevel) {
        case IdentLevel.Sdd:
          return 'SDD';
        case IdentLevel.Fdd:
          return 'FDD';
        case IdentLevel.Edd:
          return 'EDD';
      }

      return 'Unknown';
    }
    return '';
  }


  getRiskIcon() {
    if ( this.customer ) {

      const row = this.customer;

      let lvl = 0;

      if (row.riskLevelOverride != null) {
        lvl = row.riskLevelOverride;
      } else {
        lvl = row.riskLevel;
      }

      if (lvl != null) {

        if (lvl == 0) {
          return '🟢';
        }

        if (lvl == 1) {
          return '🟠';
        }

        if (lvl == 2) {
          return '🔴';
        }

      }

    }

    return '⚫️';
  }

  getRiskClass() {

    if ( this.customer ) {

      const row = this.customer;

      let lvl = 0;

      if (row.riskLevelOverride != null) {
        lvl = row.riskLevelOverride;
      } else {
        lvl = row.riskLevel;
      }

      if (lvl != null) {

        if (lvl == 0) {
          return 'risk-low-text';
        }

        if (lvl == 1) {
          return 'risk-medium-text';
        }

        if (lvl == 2) {
          return 'risk-high-text';
        }

      }

    }

    return '';


  }

  onSyncAddressToGps() {

    if ( this.customer.isAnonymized ) {
      this._toastService.error("Customer is anonymized, cannot sync address");
      return;
    }


    this.isLoadingCustomer = true;

    this.customersService.syncAddressToGps(this.customerId).subscribe(res => {
        this._toastService.success('Address sync-ed to GPS');
        this.isLoadingCustomer = false;
      },
      err => {
        this._toastService.error(err.error.Message);
        this.isLoadingCustomer = false;
      });
  }

  onSyncPersonalDataToGps() {

    if ( this.customer.isAnonymized ) {
      this._toastService.error("Customer is anonymized, cannot sync data");
      return;
    }

    this.isLoadingCustomer = true;

    this.customersService.syncPersonalDataToGps(this.customerId).subscribe(res => {
        this._toastService.success('Personal data sync-ed to GPS');
        this.isLoadingCustomer = false;
      },
      err => {
        this._toastService.error(err.error.Message);
        this.isLoadingCustomer = false;
      });
  }

  onSendSms(form: FormGroup) {


    if ( this.customer.isAnonymized ) {
      this._toastService.error("Customer is anonymized, cannot send message");
      return;
    }


    this.isSmsSending = true;
    this.customersService.sendSMS(form.value).subscribe(res => {
        this.smsForm.controls['message'].patchValue('');
        this._toastService.success('Message was sent');
        this.reloadEmailSmsLog(this.customer.id);
        this.isSmsSending = false;
    },
    err => {
      this._toastService.error(err.error.Message);
      this.isSmsSending = false;
    }
    );

  }

  splitFirstInstance(str: string,item: string): string[] {
    const res = [];
    let found = true;
    res.push('');
    for (let i = 0; i < str.length;i++){
      if (str[i] === item && found === true){
        res.push('');
        found = false;
      } else {
        res[res.length-1] += str[i];
      }
    }
    return res;
  }

  onSendPush(form: FormGroup) {


    this.isPushSending = true;

    const dataString = this.pushForm.get('dataString').value as string;
    const lines = dataString.split(/\r?\n/);
    const data: { [key: string]: string } = {};
    lines.forEach(line => {
      const d = this.splitFirstInstance(line, '=');
      data[d[0]] = d[1];
    });

    const fs = form.value;
    fs.data = data;

    this.customersService.sendPush(fs).subscribe(pushRes => {
        //this.initPushForm(this.customer);
        this._toastService.success('Push was sent to ' + pushRes.okTokens+ ' devices');
        this.reloadEmailSmsLog(this.customer.id);
        this.isPushSending = false;
      },
      err => {
        this._toastService.error(err.error.Message);
        this.isPushSending = false;
      }
    );

  }

  onSendPushData(form: FormGroup) {


    this.isPushDataSending = true;

    const fs = form.value;

    this.customersService.sendPushData(fs).subscribe(pushRes => {
        this.initPushDataForm(this.customer);
        this._toastService.success('Push Data was sent to ' + pushRes.okTokens+ ' devices');
        this.reloadEmailSmsLog(this.customer.id);
        this.isPushDataSending = false;
      },
      err => {
        this._toastService.error(err.error.Message);
        this.isPushDataSending = false;
      }
    );

  }


  reloadEmailSmsLog(id: number) {
    this.customersService.getCustomerEmailLogs(id).subscribe(result => {
      this.smsEmailLogs = result;
    });
  }

  reloadFcmSents(id: number) {
    this.isLoadingFcmSents = true;
    this.customersService.getLastFcmSents(id, 0, 100).subscribe(result => {
      this.fcmSents = result;
      this.isLoadingFcmSents = false;
    });
  }

  getSolrCustomer() {
    this.customersOverviewService.getSolr(this.customerId).subscribe(data => {
      if ( !this.customer) {
this.customer = data;
}
    });
  }


  private calculateYearsSince(dateStr: Date) : number {

    const date = new Date(dateStr);

      const currentDate = new Date();
      let y = currentDate.getFullYear() - date.getFullYear();

      // Adjust if the current date is before the account creation anniversary in the current year
      if (
        currentDate.getMonth() < date.getMonth() ||
        (currentDate.getMonth() === date.getMonth() && currentDate.getDate() < date.getDate())
      ) {
        y--;
      }
    return y;
    }



  refreshCustomer() {

    if ( !this.currentUserIsPartner()) {

      if ( !this.currentUserIsIssuerExternal()) {
        this.invoicesService.getByCustomerId(this.customerId, true).subscribe(data => {
          this.invoices = data;
        });
      }

      if ( !this.currentUserIsIssuerExternal()) {
        this.isLoadingAnnualFeeDeductions = true;
        this.annualFeeDeductionService.getByCustomerId(this.customerId).subscribe(data => {
          this.annualFeeDeductions = data;
          this.isLoadingAnnualFeeDeductions = false;
        });
      }

      if ( !this.currentUserIsIssuerExternal()) {
        this.isLoadingAnnualFees = true;
        this.annualFeeService.getByCustomerId(this.customerId).subscribe(data => {
          this.annualFees = data;
          this.isLoadingAnnualFees = false;
        });
      }

      if ( !this.currentUserIsIssuerExternal()) {
        this.isLoadingMicroPaymentSessions = true;
        this.microPaymentService.getByCustomerId(this.customerId).subscribe(data => {
          this.microPaymentSessions = data;
          this.isLoadingMicroPaymentSessions = false;
        });
      }

      if ( !this.currentUserIsIssuerExternal()) {
        this.isLoadingWhiteListedBankAccounts = true;
        this.customersService.getCustomerWhiteListedBankAccounts(this.customerId).subscribe(data => {
          this.whiteListedBankAccounts = data;
          this.isLoadingWhiteListedBankAccounts = false;
        });
      }

      this.loadHistorySums = [];
      this.loadHistoryPendingSums = [];
      this.isLoadingLoads = true;

      this.getCashbacks();

      this.getSmsDeliveries();

      this.getBankTransferLoads();

      this.inboundC2CHistorySums = [];
      this.isLoadingInboundCardToCardTransfers = true;
      this.customersService.getInboundCardToCardTransfers(this.customerId).subscribe(data => {
        this.inboundCardToCardTransfers = data;

        const lhs = new Map<number, number>();
        this.inboundCardToCardTransfers.forEach((load) => {
          if ( !lhs.has(978)) {
            lhs.set(978, 0);
          }

          lhs.set(978, lhs.get(978) + load.amount);

        });
        for (const key of lhs.keys()) {
          const acc = new AmountAndCurrencyContainer();
          acc.amount = lhs.get(key);
          acc.currencyCode = key;

          this.inboundC2CHistorySums.push(acc);
        }
        this.isLoadingInboundCardToCardTransfers = false;
      });


      this.isLoadingIdentLog = true;
      this.customersService.getIdents(this.customerId).subscribe(data => {
        this.isLoadingIdentLog = false;
        this.idents = data.map(value=> {
          const ic = new IdentContainer();
          ic.ident = value;
          return ic;
        });
      });

      this.riskService.getActiveInquiryForCustomer(this.customerId).subscribe(data => {

        this.activeRiskAssessmentInquiry = data;

        if ( data == null ) {
          this.newRiskAssessmentForm = this.formBuilder.group({
            customerId: [this.customerId],
            inquiryComment: ['', [Validators.required]],
          });
        }

      });

    }

    this.refreshResendDocButton();
    // get idv

    this.isLoadingIdvSof = true;
    this.customersService.getIdv(this.customerId).subscribe(data => {

      this.idvUploadFiles = data;
      this.isLoadingIdvSof = false;
    });

    this.loadDevicesLoggedIn();
    this.loadIbans();

    this.customersService.getOnlyAddressFiles(this.customerId).subscribe(data => {
      this.addressUploadFiles = data;
    });

    this.isLoadingAllDocuments = true;
    this.customersService.getAllDocuments(this.customerId).subscribe(data => {
      this.allDocuments = data;
      this.isLoadingAllDocuments = false;
    });






    this.isLoadingRisk = true;
    if ( !this.currentUserIsPartner()) {
      this.riskOverviewService.get(this.customerId).subscribe(data => {
        this.customerRisk = data;
        this.isLoadingRisk = false;
      });
    }

    this.isLoadingCustomer = true;
    this.isLoadingCards = true;
    this.customersService.get(this.customerId).subscribe(data => {
      this.customer = data;
      this.newIdvLevelSelect = this.customer.identLevel;
      this.newAddressStatusSelect = this.customer.addressStatus;
      this.initSmsForm(this.customer);
      this.initPushForm(this.customer);
      this.initPushDataForm(this.customer);


      this.yearsSinceAccountCreation = this.calculateYearsSince(this.customer.creationDate);

      if ( this.customer.ipAddress ) {
        this.geoIpService.getCityByIp(this.customer.ipAddress).subscribe(city => this.ipCityInfo = city, err => {});
      }

      this.getPrevNextIds(this.customerId);

      this.reloadEmailSmsLog(this.customer.id);
      this.reloadFcmSents(this.customer.id);


      // init customer edit form
      this.initCustomerEditForm(data);

      // orders aufbauen
      data.orders.forEach((item) => {
        const foundOrder = this.orders.find(this.findIndexToUpdate, item.id);

        if (foundOrder) {
          const index = this.orders.indexOf(foundOrder);
          this.orders[index].order = item;
          this.orders[index].editForm = this.initOrderEditForm(item);
          this.orders[index].invoice = item.invoice;
          if (foundOrder.invoice && foundOrder.invoice.firstOrder && foundOrder.invoice.firstOrder.voucherCode) {
            this.orders[index].invoice.firstOrder = new Order();
            this.orders[index].invoice.firstOrder.voucherCode = foundOrder.invoice.firstOrder.voucherCode;
          }

          if ( item.invoice) {
            if ( !this.currentUserIsIssuerExternal() ) {
              this.objectCommentsService.getForObject(item.invoice.id, this.commentsInvoiceTarget).subscribe((data1) => {
                this.orders[index].invoiceComments = data1;
              });
            }
          }


        } else {
          // push
          const tmp = {
            id: item.id,
            editForm: this.initOrderEditForm(item),
            order: item,
            editVisible: false,
            invoiceEditVisible: false,
            invoiceComments: [],
            invoiceEditForm: item.invoice ? this.initInvoiceEditForm(item.invoice) : null,
            invoice: item.invoice,
          };

          if (item.invoice) {

            if (item.voucherCode) {
              item.invoice.firstOrder = new Order();
              item.invoice.firstOrder.voucherCode = item.voucherCode;
            }


            if ( !this.currentUserIsIssuerExternal() ) {
              this.objectCommentsService.getForObject(item.invoice.id, this.commentsInvoiceTarget).subscribe((data) => {
                tmp.invoiceComments = data;
              });
            }
          }

          this.orders.push(tmp);
        }

      });

      // cards invoice aufbauen
      data.cards.forEach((item) => {
        const token = item.token;
        let foundCardContainer = this.cardContainers.find(this.findIndexToUpdate, item.id);

        if (foundCardContainer) {
          foundCardContainer.card = item;
          foundCardContainer.editForm = item.order.invoice ? this.initInvoiceEditForm(item.order.invoice) : null;

          if (item.order.invoice) {
            if ( !this.currentUserIsIssuerExternal() ) {
this.objectCommentsService.getForObject(item.order.invoice.id, this.commentsInvoiceTarget).subscribe((data) => {
                foundCardContainer.invoiceComments = data;
              });
}
          }


        } else {
          // push
          const tmp = {
            id: item.id,
            editForm: item.order.invoice ? this.initInvoiceEditForm(item.order.invoice) : null,
            card: item,
            gpsCardStatusCached: null,
            editVisible: false,
            invoiceComments: [],
            statement: null,
            financialStatements: null,
            cardholderDetails: null,
            cardInfo: null,
            cashbackSummary: null,
            gpsPosDataList: new Map<string, GPSPosData>(),
          } as CustomerOverviewCardContainer;

          if (item.order.invoice) {
            if ( !this.currentUserIsIssuerExternal() ) {
this.objectCommentsService.getForObject(item.order.invoice.id, this.commentsInvoiceTarget).subscribe((data) => {
                tmp.invoiceComments = data;
              });
}
          }






          this.cardContainers.push(tmp);
          foundCardContainer = tmp;
        }

        const currentCard = foundCardContainer;

        this.cardsService.getCardCashbackSummary(token).subscribe(cbs => {
          currentCard.cashbackSummary = cbs;
        });
        this.cardsService.getLastKnownAvailableBalance(token).subscribe(bal => {
          if ( bal != null ) {
currentCard.lastKnownAvailableBalance = bal.avlBal;
}
        });

        this.cardsService.getGpsCardStatusCached(token).subscribe(status => {
          currentCard.gpsCardStatusCached = status;
        }, err => {
          this._toastService.error('Failed to query GPS card status for ' + token);
        });

        this.cardsService.getPendingExtension(token).subscribe(pe => {
          currentCard.pendingExtension = pe;
        }, err => {
          this._toastService.error('Failed to query pending extensions for ' + token);
        });

        this.cardsService.getPendingReorder(token).subscribe(pr => {
          currentCard.pendingReorder = pr;
        }, err => {
          this._toastService.error('Failed to query pending reorders for ' + token);
          // do nothing
        });
        this.cardsService.getCardExtensions(token).subscribe(cardExtensions => {
          currentCard.extensions = cardExtensions;
        }, err => {
          this._toastService.error('Failed to query extensions for ' + token);
        });

        this.cardsService.getCardExtensions(token).subscribe(cardExtensions => {
          currentCard.extensions = cardExtensions;
        }, err => {
          this._toastService.error('Failed to query extensions for ' + token);
        });

        this.getProductLogoUrl(currentCard.card.productId);

      });



      this.isLoadingCards = false;

    });

    this.isLoadingCustomer = false;
    this.isLoadingLogs = true;
    this.logService.get(15, this.customerId).subscribe(data => {
      this.logs = data;
      this.isLoadingLogs = false;
    });
  }


  // FIXME: there should be a function reimplemented that reloads the customer's cards only
  /*refreshCards() {
    this.cardsService.getForCustomer(this.customerId).subscribe(data => {
      this.customer.cards = data;
    });
  }*/
  _isSettingIdentLevel = false;
  _isSettingPepStatus = false;

  onRiskAssesmentFormSubmit() {
    this.disableRiskAssBtn = true;
    const req = new RiskAssementInquiry();
    req.customerId = this.customerId;
    req.inquiryComment = this.newRiskAssessmentForm.value.inquiryComment;
    this.riskService.add(req)
      .subscribe(res => {
        this.refreshCustomer();
        this.disableRiskAssBtn = false;
      });
  }


  showLogs() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'compliance']);
  }


  downloadAttachment(transactionId: number) {

    if ( !this.isWebIdDownloadVisible ) {
      return;
    }

    this.transactionService.getAttachment(transactionId).subscribe(
      result => {
        FileHelper.saveFile(result);
      },
      err =>
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        })
    );
  }

  IsNaN(number: any) {
    return isNaN(parseInt(number));
  }

  getCustomerOverviewTableFilters() {
    const a = getTableFilters('customerOverviewTable');
    return a;
  }

  getPrevNextIds(id: number) {
    const filters = this.getCustomerOverviewTableFilters();
    this.customersOverviewService.getPrevNextIds(filters, id).subscribe(result => {
      this.prevNextIds = result;
    });
  }

  gotoPrevCustomer() {
    this.previewFileOpen = false;
    if ( this.prevNextIds?.prevId == null ) {
      this._toastService.error('no previous customer');
    }

    this.loadingPrevNext = true;
    this.loadingPrev = true;
    this.router.navigate(['..', this.prevNextIds.prevId], {relativeTo: this.route});
    this.loadingPrevNext = false;
    this.loadingPrev = false;
  }

  gotoNextCustomer() {
    this.previewFileOpen = false;
    if ( this.prevNextIds?.nextId == null ) {
      this._toastService.error('no next customer');
    }

    this.loadingPrevNext = true;
    this.loadingNext = true;
    this.router.navigate(['..', this.prevNextIds.nextId], {relativeTo: this.route});
    this.loadingPrevNext = false;
    this.loadingNext = false;
  }

  clearData() {
    this.prevNextIds = null;
    this.smsEmailLogs = [];
    this.allDocuments = [];
  }


  isGpsButtonEnabled() {
    const ok = this.roleService.hasRoles(['admin', 'manager', 'compliance', 'issuer_external']);

    if (this.currentUserIsPartner()) {
      return this.userIsPartnerAndCardProcessorEnquiryEnabled;
    }

    return ok;

  }

  getCardholderDetails(card: CustomerOverviewCardContainer) {

    // test: "125130184"
    this.isCardholderDetailsLoading = true;

    this.cardbroGatewayService.getCardholderDetails(card.card.token).subscribe(data => {
      card.statement = null;
      card.cardInfo = null;
      card.cardholderDetails = data;
      this.isCardholderDetailsLoading = false;
    },
    err => {
      this.showError(err.error.message || err.error || err.message);
      this.isCardholderDetailsLoading = false;
    });


  }

  getCardInfos(card: CustomerOverviewCardContainer) {


    this.isCardInfoLoading = true;

    this.cardbroGatewayService.getCardInfo(card.card.token).subscribe(data => {
      card.statement = null;
      card.cardholderDetails = null;
      card.cardInfo = data;
      this.isCardInfoLoading = false;
    },
    err => {
      this.showError(err.error.message || err.error || err.message);
      this.isCardInfoLoading = false;
    });

  }

  cancelCard(card: Card) {
    this.dialog.open(CardCancellationDialogComponent).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CardCancellationModel) {

          this.cardsService.cancelCard(card.id, dlgResult).subscribe(result => {
            this._toastService.info('Card cancelled');

          });

          this.refreshCustomer();


        }
      });
  }

  getStatement2(card: CustomerOverviewCardContainer) {

    this.isStatementLoading = true;
    this.cardbroGatewayService.getStatement2Ehi(card.card.token).subscribe(data => {

        card.cardholderDetails = null;
        card.cardInfo = null;
        card.statement2 = data;


        if (card.statement2 != null && card.statement2.length > 0) {

          card.statement2.forEach((item: StatementLineDto) => {
            if (item.isCredit) {

            }

            if (!item.isCredit) {
              item.txnAmt = item.txnAmt * -1;
              //item.billAmount = item.billAmount * -1;
            }

          });
        }

        card.statement2.forEach(value => {
          const gpsPosDataStr = value.gpsPosData;
          const gpsPosDataStruct = parseGPSPosData(gpsPosDataStr);
          card.gpsPosDataList.set(value.gpsPosData, gpsPosDataStruct);

        });


        card.statement2DataSource = new MatTableDataSource<StatementLineDto>(card.statement2);
        card.statement2DataSource.paginator = this.paginatorStatement;
        this.isStatementLoading = false;
        // console.log( data.financialTransactions );
      },
      err => {
        this.showError(err.error.message || err.error || err.message);
        this.isStatementLoading = false;
      }
    );
  }



  onSelect(event) {
    // console.log(event);
    this.files.push(...event.addedFiles);
  }

  onSelectSof(event) {
    // console.log(event);
    this.filesSof.push(...event.addedFiles);
  }

  onSelectAddressConfirmation(event) {
    // console.log(event);
    this.filesAddressConfirmation.push(...event.addedFiles);
  }

  upload() {

    this.showUploadError = false;
    this.isUploading = true;
    this.disabled = true;


    const formData = new FormData();

    if (this.files.length > 0) {
      // other files
      for (let i = 0; i < this.files.length; i++) {
        formData.append('file[]', this.files[i]);
        formData.append('docTypes[]', '0');

      }
    }



    this.idvCustomersService.uploadFiles(this.lastDocLinkToken, formData).subscribe(result => {
        if (result) {
          this.isUploading = false;
          this.disabled = true;
          this.showUploadError = false;
          this.files = [];
          this.refreshCustomer();
        }
      },
      error => {
        this.showUploadError = true;
        this.isUploading = false;
        this.disabled = false;
      });

  }

  uploadSofGeneric() {

    this.showUploadError = false;
    this.isUploading = true;
    this.disabled = true;


    const formData = new FormData();

    if (this.filesSof.length > 0) {
      // other files
      for (let i = 0; i < this.filesSof.length; i++) {
        formData.append('file[]', this.filesSof[i]);
        formData.append('docTypes[]', '0');

      }
    }

    if ( !this.lastSofGenericLinkToken ) {
      // create a sof token on the fly, but do not send it
      this.idvCustomersService.silentCreateSofGenericLinkToken(this.customer.id).subscribe(token => {
        this.lastSofGenericLinkToken = token;
        this.uploadSofFiles(this.lastSofGenericLinkToken, formData);
      });
    } else {
      this.uploadSofFiles(this.lastSofGenericLinkToken, formData);
    }

  }

  uploadAddressConfirmation() {

    this.showUploadError = false;
    this.isUploading = true;
    this.disabled = true;


    const formData = new FormData();

    formData.append('setFinished', '1'); // this will be ignored because it seemingly does not work

    if (this.filesAddressConfirmation.length > 0) {
      // other files
      for (let i = 0; i < this.filesAddressConfirmation.length; i++) {
        formData.append('file[]', this.filesAddressConfirmation[i]);
        formData.append('docTypes[]', '0');
      }
    }



    if ( !this.lastAddressConfirmationLinkToken ) {
      // create a address confirmation token on the fly, but do not send it
      this.idvCustomersService.silentAddressConfirmationLinkToken(this.customer.id).subscribe(token => {
        this.lastAddressConfirmationLinkToken = token;
        this.uploadAddressConfirmationFiles(this.lastAddressConfirmationLinkToken, formData);
      });
    } else {
      this.uploadAddressConfirmationFiles(this.lastAddressConfirmationLinkToken, formData);
    }

  }


  uploadSofFiles(token: string, formData: any) {
    this.idvCustomersService.uploadFiles(this.lastSofGenericLinkToken, formData).subscribe(result => {
        if (result) {
          this.isUploading = false;
          this.disabled = true;
          this.showUploadError = false;
          this.filesSof = [];
          this.refreshCustomer();
        }
      },
      error => {
        this.showUploadError = true;
        this.isUploading = false;
        this.disabled = false;
      });
  }

  uploadAddressConfirmationFiles(token: string, formData: any) {
    this.idvCustomersService.uploadFiles(this.lastAddressConfirmationLinkToken, formData).subscribe(result => {
        if (result) {
          this.isUploading = false;
          this.disabled = true;
          this.showUploadError = false;
          this.filesAddressConfirmation = [];
          this.refreshCustomer();
        }
      },
      error => {
        this.showUploadError = true;
        this.isUploading = false;
        this.disabled = false;
      });
  }

  onRemove(event) {
    // console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  onRemoveSof(event) {
    // console.log(event);
    this.filesSof.splice(this.filesSof.indexOf(event), 1);
  }

  onRemoveAddressConfirmation(event) {
    // console.log(event);
    this.filesAddressConfirmation.splice(this.filesAddressConfirmation.indexOf(event), 1);
  }

  currentUserIsAdminOrComplianceOrManager(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance', 'manager']);
  }

  getIdentProviderCodeString1(providerCode: number) {
    return WebIdTransactionProvider[providerCode] || 'unknown';
  }

  getIdentStatusString1(status: IdentStatus) {
    return IdentStatus[status] || 'unknown';
  }

  removeCardFromCashbackGroup(card: Card, cashbackGroup: CashbackGroup) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Remove from cashback group',
        text: 'Are you sure you want to remove ' + card.token + ' from cashback group ' + cashbackGroup.name + '?',
        confirm: 'Ok',
        cancel: 'Cancel'
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult == 'ok') {

          this.cashbackGroupsService.removeCardFromCashbackGroup(card.id, cashbackGroup.id).subscribe(result => {
            this.refreshCustomer();
          });

        }
      });
  }

  setCustomerIdLevel() {
    this._isSettingIdentLevel = true;
    this.customersService.setIdentLevel(this.customer, this.newIdvLevelSelect).subscribe(
      data => {
        this._toastService.success('New Ident Level has been set');
        this.customer.identLevel = this.newIdvLevelSelect;
        this._isSettingIdentLevel = false;
        this.loadComments();
        setTimeout(() => this.loadComments(), 5000);
        setTimeout(() => this.loadComments(), 10000);
        setTimeout(() => this.loadComments(), 20000);
      }, err => {
        this._toastService.error('Error setting new Ident Level: ' + err);
        this._isSettingIdentLevel = false;
      }
    );
  }

  setCustomerPepStatus() {
    this._isSettingPepStatus = true;
    this.customersService.setPepStatus(this.customer, this.newPepStatusToSelect).subscribe(
      data => {
        this._toastService.success('New PEP status has been set');
        this.customer.pepStatus = this.newPepStatusToSelect;
        this._isSettingPepStatus = false;
        this.loadComments();
        setTimeout(() => this.loadComments(), 5000);
        setTimeout(() => this.loadComments(), 10000);
        setTimeout(() => this.loadComments(), 20000);
      }, err => {
        this._toastService.error('Error setting new PEP status: ' + err);
        this._isSettingPepStatus = false;
      }
    );
  }

  setCustomerAddressStatus(newAddressStatusSelect: AddressStatus) {
    this.customersService.setAddressStatus(this.customer, this.newAddressStatusSelect).subscribe(
      data => {
        this._toastService.success('New Address Status has been set');
        this.customer.addressStatus = this.newAddressStatusSelect;
        this.loadComments();
        setTimeout(() => this.loadComments(), 5000);
        setTimeout(() => this.loadComments(), 10000);
        setTimeout(() => this.loadComments(), 20000);
      }, err => {
        this._toastService.error('Error setting new Address Status: ' + err);
      }
    );
  }

  private loadComments() {
    this.isLoadingComments = true;
    if ( !this.currentUserIsIssuerExternal() ) {
this.objectCommentsService.getForObject(this.customerId, this.commentsTarget).subscribe(data => {
        this.comments = data;
        this.isLoadingComments = false;
      });
}
  }

  getIdentDocumentType(identDocumentType: number): string {
    if ( identDocumentType === 0 ) {
return 'NONE';
}
    if ( identDocumentType === 1 ) {
return 'PASSPORT';
}
    if ( identDocumentType === 2 ) {
return 'DRIVERS_LICENSE';
}
    if ( identDocumentType === 3 ) {
return 'ID_CARD';
}
    if ( identDocumentType === 4 ) {
return 'RESIDENCE_PERMIT';
}

    return 'Other';
  }

  editCustomerIdentDocument() {
    this.dialog.open(CustomerIdentEditDialogComponent, {
      data: {
        dob: this.customer.identDocumentDob ?? this.customer.dob,
        firstName: this.customer.identDocumentFirstName ?? this.customer.firstName,
        lastName: this.customer.identDocumentLastName ?? this.customer.lastName,
        documentType: this.customer.identDocumentType,
        documentExpiry: this.customer.identValidUntilDate,
        documentNumber: this.customer.identDocumentNumber,
        documentCountry: this.customer.identDocumentCountry,
      },
      maxWidth: 400,
    }).afterClosed().subscribe(data => {
      if (data) {

        this.customersService.updateIdentDocument(this.customerId, data).subscribe(res2 => {
          const d = data as CustomerIdentDocumentModel;
          this._toastService.success('Ident Document successfully updated');
          this.customer.identDocumentType = d.documentType;
          this.customer.identDocumentFirstName = d.firstName;
          this.customer.identDocumentLastName = d.lastName;
          this.customer.identDocumentNumber = d.documentNumber;
          this.customer.identValidUntilDate = d.documentExpiry;
          this.customer.identDocumentDob = d.dob;
          this.customer.identDocumentCountry = d.documentCountry;
        }, err => {
          this._toastService.error(err.error.message || err.error || err.message);
        });
      }
    });
  }

  getIdentFiles(identId: number) {
    this.isLoadingIdentFiles = true;
    this.customersService.getIdentFiles(identId).subscribe(oh => {
      const identContainer = this.idents.find(value => value.ident.id == identId);
      identContainer.files = oh;
      this.isLoadingIdentFiles = false;
    }, error => {
      this.isLoadingIdentFiles = false;
      this._toastService.error("Failed to load Ident files");
    });

  }


  closePreview() {
    this.previewFileOpen = false;
  }

  orderNewCard() {

    this.dialog.open(AddCardOrderDialogComponent, {
      data: {
        title: 'Add a new card order',
        text: 'Please confirm the new card to order for ' + this.customer.firstName + ' ' + this.customer.lastName,
        customerId: this.customerId
      }
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof CreateCardOrderModel) {

          this.isOrderingNewCard = true;

          dlgResult.customerId = this.customerId;

          this.ordersService.createInternalOrder(dlgResult).subscribe(result => {

            this.isOrderingNewCard = false;
              this._toastService.success('The order has been created');

              // navigate to the newly created order
              this.router.navigate(['../../orders/' + result.id], {relativeTo: this.route}).then();

          }, err => {
            this._toastService.error(err.error.message || err.message || err.error || err);
            this.isOrderingNewCard = false;
          });


        }
      });



    // TODO show a dialog to select the card product and type and let the backend create a order


  }

  private getCashbacks() {
    this.cashbacks = [];
    this.customersService.getCashbacks(this.customerId).subscribe(data => {
      this.cashbacks = data.reverse();
    });
  }

  private getBankTransferLoads() {
    this.isLoadingBankTransferLoads = true;
    this.customersService.getBankTransferLoads(this.customerId).subscribe(data => {
      this.loadHistory = data;
      this.isLoadingLoads = false;
      const lhs = new Map<number, number>();
      const lhps = new Map<number, number>();
      this.loadHistory.forEach((load) => {
        if ( !lhs.has(load.currencyCode)) {
          lhs.set(load.currencyCode, 0);
        }
        if ( !lhps.has(load.currencyCode)) {
          lhps.set(load.currencyCode, 0);
        }

        lhs.set(load.currencyCode, lhs.get(load.currencyCode) + load.amountAlreadyLoaded);
        lhps.set(load.currencyCode, lhps.get(load.currencyCode) + (load.isMarkedForRefund || load.isRefunded ? 0 : (load.amountToLoad - load.amountAlreadyLoaded)));


      });
      for (const key of lhs.keys()) {
        const acc = new AmountAndCurrencyContainer();
        acc.amount = lhs.get(key);
        acc.currencyCode = key;

        this.loadHistorySums.push(acc);
      }

      for (const key of lhps.keys()) {
        const acc = new AmountAndCurrencyContainer();
        acc.amount = lhps.get(key);
        acc.currencyCode = key;

        this.loadHistoryPendingSums.push(acc);
      }


      this.isLoadingBankTransferLoads = false;

    });
  }


  private getSmsDeliveries() {
    this.smsDeliveries = [];
    this.customersService.getSmsDeliveries(this.customerId).subscribe(data => {
      // TODO CCL-002?

      this.smsDeliveries = data;
    });
  }

  anonymizeCustomer(customer: Customer) {

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Anonymize customer data',
        text: 'Are you sure you want to anonymize this customer\'s data?'
      },
      minWidth: 350,
    })
        .afterClosed()
        .subscribe(result => {
          if (result == 'ok') {
            this.isAnonymizing = true;
            this.customersService.anonymizeCustomer(customer.id).subscribe(_ => {
              this._toastService.success("Customer data has been anonymized");
              this.loadCustomerData();
              this.isAnonymizing = false;
            });
          }
        });



  }

  restoreAnonymizedCustomer(customer: Customer) {


    this.dialog.open(RestoreAnonymizedDialogComponent, {

    })
        .afterClosed()
        .subscribe((privateKeyPem: string) => {

          if ( !privateKeyPem )
            return;

          this.isAnonymizing = true;
          this.customersService.restoreAnonymizeCustomer(this.customerId, privateKeyPem).subscribe(data => {
            this._toastService.success('Customer data was restored');

            this.loadCustomerData();
            this.isAnonymizing = false;

          }, err => {

            this._toastService.error(err.error.message || err.message || err.error || err);
          });
        });

  }

  logoutDevice(deviceToken: string) {

    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Logout device', text: 'Are you sure you want to log out this device?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          this.isLoadingDevicesLoggedIn = true;
          this.customersService.logoutDevice(deviceToken).subscribe(data => {
            this.showSuccess('Device logout has been requested');
            setTimeout(() => {
              this.loadDevicesLoggedIn();
            }, 2000);

          }, err => {

            this.showError(err.error.message || err.error || err.message || err);
            this.isLoadingDevicesLoggedIn = false;
          });

        }
      });




    return false;



  }

  private loadDevicesLoggedIn() {
    this.isLoadingDevicesLoggedIn = true;
    this.customersService.getDevicesLoggedIn(this.customerId).subscribe(data => {

      this.devicesLoggedIn = data.reverse();

      this.isLoadingDevicesLoggedIn = false;
    });
  }

  private loadIbans() {
    this.isLoadingIbans = true;
    this.customersService.getIbans(this.customerId).subscribe(data => {
      this.ibans = data;
      this.isLoadingIbans = false;
    });
  }


  protected readonly ThreeDSecureAuthMethod = ThreeDSecureAuthMethod;
  protected readonly CardPresent = CardPresent;
  protected readonly CardholderPresent = CardholderPresent;
  protected readonly CardDataInputMethod = CardDataInputMethod;
  protected readonly SCATestResult = SCATestResult;
  protected readonly AuthenticationMethod = AuthenticationMethod;

  isPinAuth(gpsPosData: GPSPosData|null) : boolean {
    if ( gpsPosData == null ) return false;
    return (gpsPosData.cardholderAuthMethod1) == AuthenticationMethod.PIN || (gpsPosData.cardholderAuthMethod2) == AuthenticationMethod.PIN || (gpsPosData.cardholderAuthMethod3) == AuthenticationMethod.PIN || (gpsPosData.cardholderAuthMethod4 ?? false) == AuthenticationMethod.PIN;
  }

  isSecure3DsAuth(gpsPosData: GPSPosData|null) : boolean {
      if ( gpsPosData == null ) return false;
      return (gpsPosData.cardholderAuthMethod1) == AuthenticationMethod.Secure3DS || (gpsPosData.cardholderAuthMethod2) == AuthenticationMethod.Secure3DS || (gpsPosData.cardholderAuthMethod3) == AuthenticationMethod.Secure3DS || (gpsPosData.cardholderAuthMethod4 ?? false) == AuthenticationMethod.Secure3DS;
  }

  isBiometricsAuth(gpsPosData: GPSPosData|null) : boolean {
      if ( gpsPosData == null ) return false;
      return (gpsPosData.cardholderAuthMethod1) == AuthenticationMethod.Biometrics || (gpsPosData.cardholderAuthMethod2) == AuthenticationMethod.Biometrics || (gpsPosData.cardholderAuthMethod3) == AuthenticationMethod.Biometrics || (gpsPosData.cardholderAuthMethod4 ?? false) == AuthenticationMethod.Biometrics;
  }

  markAsVulnerable(customer: Customer) {

    this.isMarkingAsVulnerable = true;
    const dialogRef = this.dialog.open(MarkVulnerableDialogComponent, {
      data: {
        title: 'Mark customer as vulnerable',
        text: 'Are you sure want to mark this customer as vulnerable?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result instanceof MarkCustomerAsVulnerableModel) {
        this.customersService.markVulnerable(customer.id, result.reason, 'CUS').subscribe(_ => {
          this.customer.isVulnerable = true;
          this.customer.vulnerableDate = new Date();
          this.customer.vulnerableReason = result.reason;
          this._toastService.info('Customer was marked as vulnerable');
          this.isMarkingAsVulnerable = false;
        });
      } else {
        this.isMarkingAsVulnerable = false;
      }
    });



  }

  isMarkingAsVulnerable = false;

  getSofTypeName(typName: string) {
    if ( typName == "SOFGENERIC")
      return "SOF generic";
    if ( typName == "SOFSINGLE")
      return "SOF single";

    return typName;
  }

  getPoaTypeName(typName: string) {
    if ( typName == "ADDRESSCONFIRMATION")
      return "Address confirmation";
    if ( typName == "ADDRESS")
      return "Address change";

    return typName;
  }

  protected readonly environment = environment;
  public eTransactionStatus = ETransactionStatus;
  public expandedStatementElement: StatementLineDto|null;

  getProductLogoUrl(productId: number) {
    this.productService.getLogoFilename(productId).subscribe(logoFileName => {this.productLogoUrl[productId] = environment.apiUrl + logoFileName;})
  }

  txnIsLoad(element: StatementLineDto) {
    return this.txnIs(element, 'L');
  }
  txnIsUnload(element: StatementLineDto) {
    return this.txnIs(element, 'U');
  }
  txnIsBalanceAdj(element: StatementLineDto) {
    return this.txnIs(element, 'B');
  }

  txnNote(element: StatementLineDto) : string|null {
    const note = element.transactions && element.transactions.length > 0 ? element.transactions[0].note : null;

    if ( note == null )
      return null;

    // TODO normalize reasons for declines here?

    return note;

  }


  private txnIs(element: StatementLineDto, txnType: string) {
    return element.transactions && element.transactions.length > 0 && element.transactions[0].txnType === txnType;
  }

  protected readonly ETransactionStatus = ETransactionStatus;
  protected readonly JSON = JSON;
}
